const CLIENT_BUILD = "20260512bloodpointgoal17";
const OVERLAY_EDITOR_WIDTH = 1920;
const OVERLAY_EDITOR_HEIGHT = 1080;
const OVERLAY_LAYOUT_DEFAULT = { bonusPanel: { x: -7, y: -18, side: "left", scale: 1 }, progressPanel: { x: 530, y: -30, scale: 1 }, donationPanel: { x: 1536, y: 248, side: "right", scale: 1 }, resultsPanel: { x: 580, y: 320, scale: 1 } };
const OVERLAY_EDITOR_PANELS = { bonusPanel: { label: "Bonos", width: 440, height: 276 }, progressPanel: { label: "Barra", width: 860, height: 232 }, donationPanel: { label: "Donaciones", width: 384, height: 108 }, resultsPanel: { label: "Resultados", width: 760, height: 320 } };
const numberFormatter = new Intl.NumberFormat("en-US");
const DONATION_RATE_ORDER = ["bits", "kicks", "streamlabs_usd"];
const DONATION_RATE_META = {
  bits: { label: "Bits", shortLabel: "Bits", unit: "bits" },
  kicks: { label: "Kicks", shortLabel: "Kicks", unit: "kicks" },
  streamlabs_usd: { label: "Streamlabs USD", shortLabel: "Streamlabs", unit: "USD" }
};
const fixedDonationRateIds = new Set(DONATION_RATE_ORDER);
const preloadedKillerImages = new Set();
const PROGRESS_ANIMATION_MS = 3500;
const PROGRESS_HOLD_MS = 5000;
const PROGRESS_FADE_MS = 500;
const PROGRESS_TOTAL_MS = PROGRESS_ANIMATION_MS + PROGRESS_HOLD_MS + PROGRESS_FADE_MS;
const MATCH_STATUS_PENDING_BONUSES = "pending_bonuses";
const MATCH_STATUS_PENDING_PENALTIES = "pending_penalties";
const MATCH_STATUS_COMPLETE = "complete";
const MATCH_PENALTY_ITEMS = [
  { id: "pallet_save", text: "Los supervivientes hacen un Pallet Save", bp: 10000 },
  { id: "flashlight_save", text: "Los supervivientes hacen un Flashlight Save", bp: 10000 },
  { id: "de_frente_save", text: "Los supervivientes hacen un De Frente Save", bp: 10000 },
  { id: "evade_360", text: "Los supervivientes hacen un 360 evadiendo un hit o haciendo contraflick", bp: 5000 },
  { id: "open_exit_gates", text: "Abrirte las puertas", bp: 5000 }
];
const GENERAL_AFK_BONUS_ID = "general-05-ganar-estando-afk";

const state = {
  snapshot: null,
  selectedKillerId: "",
  killerCounts: {},
  generalCounts: {},
  penaltyCounts: {},
  hooksCount: 0,
  gensCount: 0,
  escapesCount: 0,
  resultModalOpen: false,
  resultStep: "base",
  resultBaseBp: "",
  resetConfirmOpen: false,
  editModalOpen: false,
  editKind: "",
  editId: 0,
  editValues: {},
  overlayEditorOpen: false,
  overlayLayoutDraft: null,
  overlayEditorFocusKey: "bonusPanel",
  overlayDrag: null,
  overlayResize: null,
  killerModalOpen: false,
  killerSearch: "",
  historyTab: "matches",
  modifierTab: "bonuses",
  clientKey: getClientKey(),
  isMain: false,
  ws: null,
  streamlabsSocket: null,
  streamlabsLoading: false,
  completedMatchIds: new Set(),
  completedBaseIdempotencyKeys: new Set(),
  pendingBaseSync: null,
  pendingRequests: new Set(),
  optimisticCounter: 0,
  dashboardHydrated: false,
  dashboardLastAnimatedEventKey: "",
  dashboardLastAnimatedEventSignature: "",
  dashboardActiveAnimation: null,
  dashboardAnimationTimer: 0,
  dashboardEventQueue: [],
  dashboardQueuedEventKeys: new Set(),
  dashboardQueuedEventSignatures: new Set(),
  backdropPointerDownAction: "",
  configDraft: null,
  error: "",
  success: ""
};

function actionLabel(action, fallback) {
  return state.pendingRequests.has(action) ? "Enviando..." : fallback;
}

function appBase() {
  const first = window.location.pathname.split("/").filter(Boolean)[0] || "";
  return first.toLowerCase() === "bloodpointgoal" ? `/${first}` : "";
}

function appPath(path) {
  return `${appBase()}${path.startsWith("/") ? path : `/${path}`}`;
}

function normalizeMatchStatus(value) {
  const raw = String(value || "").trim().toLowerCase();
  if (raw === "pending") return MATCH_STATUS_PENDING_BONUSES;
  if (raw === MATCH_STATUS_PENDING_BONUSES || raw === MATCH_STATUS_PENDING_PENALTIES || raw === MATCH_STATUS_COMPLETE) return raw;
  return MATCH_STATUS_COMPLETE;
}

function getClientKey() {
  const key = "bloodpointgoal_client_key_v1";
  let value = sessionStorage.getItem(key);
  if (!value) {
    value = `browser:${crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}${Math.random()}`}`;
    sessionStorage.setItem(key, value);
  }
  return value;
}

function createIdempotencyKey(scope) {
  const random = crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random()}`;
  return `${state.clientKey}:${scope}:${random}`.slice(0, 96);
}

function nextOptimisticId() {
  state.optimisticCounter += 1;
  return -Math.max(1, state.optimisticCounter);
}

function cloneSnapshot(snapshot = state.snapshot) {
  return snapshot ? JSON.parse(JSON.stringify(snapshot)) : null;
}

function fmt(value) {
  return numberFormatter.format(Math.trunc(Number(value) || 0));
}

function pct(current, goal) {
  const g = Math.max(1, Number(goal) || 1);
  return Math.max(0, Math.min(100, ((Number(current) || 0) / g) * 100));
}

function eventKey(event) {
  if (!event) return "";
  return [event.kind || event.source || "event", event.id || "0", event.createdAt || "0", event.progressAfter || "0"].join(":");
}

function eventSignature(event) {
  if (!event) return "";
  const before = Math.max(0, Number(event.progressBefore) || 0);
  const after = Math.max(0, Number(event.progressAfter) || 0);
  const delta = Number.isFinite(Number(event.deltaBp)) ? Number(event.deltaBp) : after - before;
  return [event.source || event.kind || "event", event.action || (delta < 0 ? "subtract" : "add"), Math.trunc(delta), before, after].join(":");
}

function segmentType(type) {
  const normalized = String(type || "").toLowerCase();
  if (normalized === "bonus" || normalized === "donation" || normalized === "subtract") return normalized;
  return "base";
}

function normalizedProgressBreakdown(snapshot) {
  const challenge = snapshot && snapshot.challenge || {};
  const breakdown = snapshot && snapshot.progressBreakdown || {};
  const currentBp = Math.max(0, Number(challenge.currentBp ?? breakdown.currentBp) || 0);
  const goalBp = Math.max(1, Number(challenge.goalBp ?? breakdown.goalBp) || 1);
  return { currentBp, goalBp, lastEvent: breakdown.lastEvent || null };
}

function progressStyle(width) {
  const clamped = Math.max(0, Math.min(100, Number(width) || 0));
  return `--left:var(--track-fill-left);--width:calc(var(--track-fill-width) * ${clamped.toFixed(3)} / 100)`;
}

function renderProgressLayer(className, currentBp, goalBp) {
  const width = pct(currentBp, goalBp);
  if (width <= 0) return "";
  return `<span class="${className}" style="${progressStyle(width)}"></span>`;
}

function renderStaticProgress(currentBp, goalBp) {
  return renderProgressLayer("overlay-bar-segment overlay-bar-base", currentBp, goalBp);
}

function renderFinalProgress(currentBp, goalBp) {
  return renderProgressLayer("overlay-bar-final overlay-bar-base", currentBp, goalBp);
}

function eventFillType(event) {
  if (!event || event.action === "subtract" || Number(event.deltaBp) < 0) return "subtract";
  const types = (Array.isArray(event.segments) ? event.segments : []).map((segment) => segmentType(segment && segment.type));
  if (types.includes("donation")) return "donation";
  if (types.includes("bonus")) return "bonus";
  return "base";
}

function queueDashboardProgressEvent(event) {
  const key = eventKey(event);
  const signature = eventSignature(event);
  if (!key || state.dashboardLastAnimatedEventKey === key || state.dashboardQueuedEventKeys.has(key)) return;
  if (signature && (state.dashboardLastAnimatedEventSignature === signature || state.dashboardQueuedEventSignatures.has(signature))) return;
  if (state.dashboardActiveAnimation && (state.dashboardActiveAnimation.key === key || state.dashboardActiveAnimation.signature === signature)) return;
  state.dashboardQueuedEventKeys.add(key);
  if (signature) state.dashboardQueuedEventSignatures.add(signature);
  state.dashboardEventQueue.push(event);
}

function scheduleDashboardAnimationEnd(key, duration) {
  if (state.dashboardAnimationTimer) clearTimeout(state.dashboardAnimationTimer);
  state.dashboardAnimationTimer = setTimeout(() => {
    if (state.dashboardActiveAnimation && state.dashboardActiveAnimation.key === key) {
      state.dashboardActiveAnimation = null;
      render();
    }
  }, duration);
}

function withDashboardAnimationOffset(html, startedAt) {
  const elapsed = Math.max(0, Math.min(PROGRESS_TOTAL_MS, Date.now() - (Number(startedAt) || Date.now())));
  if (!elapsed) return html;
  return String(html || "").replace(/style="([^"]*)"/g, `style="$1;animation-delay:-${Math.trunc(elapsed)}ms"`);
}

function renderDashboardEventAnimation(event, goalBp) {
  if (state.dashboardActiveAnimation && state.dashboardActiveAnimation.endsAt > Date.now()) {
    return { html: withDashboardAnimationOffset(state.dashboardActiveAnimation.html, state.dashboardActiveAnimation.startedAt), staticBp: state.dashboardActiveAnimation.staticBp };
  }

  const directKey = eventKey(event);
  if (directKey && state.dashboardLastAnimatedEventKey !== directKey && !state.dashboardQueuedEventKeys.has(directKey)) queueDashboardProgressEvent(event);
  const nextEvent = state.dashboardEventQueue.shift();
  if (!nextEvent) return { html: "", staticBp: null };
  const key = eventKey(nextEvent);
  const signature = eventSignature(nextEvent);
  state.dashboardQueuedEventKeys.delete(key);
  if (signature) state.dashboardQueuedEventSignatures.delete(signature);
  if (!key || state.dashboardLastAnimatedEventKey === key || (signature && state.dashboardLastAnimatedEventSignature === signature)) return { html: "", staticBp: null };
  event = nextEvent;

  const before = Math.max(0, Number(event.progressBefore) || 0);
  const after = Math.max(0, Number(event.progressAfter) || 0);
  const type = eventFillType(event);
  const isSubtract = type === "subtract";
  const fromPct = pct(before, goalBp);
  const toPct = pct(after, goalBp);
  const width = isSubtract ? fromPct : toPct;
  if (width <= 0) return { html: "", staticBp: null };

  const fromScale = isSubtract ? 1 : Math.max(.001, fromPct / Math.max(.001, toPct));
  const toScale = isSubtract ? Math.max(.001, toPct / Math.max(.001, fromPct)) : 1;
  const finalLayer = renderFinalProgress(after, goalBp);
  const eventStyle = `${progressStyle(width)};--from-scale:${fromScale.toFixed(4)};--to-scale:${toScale.toFixed(4)}`;
  const eventLayer = isSubtract
    ? `<span class="overlay-bar-event overlay-bar-bonus overlay-bar-event-loss-fill" style="${eventStyle}"></span>`
    : `<span class="overlay-bar-event overlay-bar-${type}" style="${eventStyle}"></span>`;
  const html = `${finalLayer}${eventLayer}`;
  const staticBp = isSubtract ? after : before;

  state.dashboardLastAnimatedEventKey = key;
  state.dashboardLastAnimatedEventSignature = signature;
  const startedAt = Date.now();
  state.dashboardActiveAnimation = { key, signature, html, staticBp, startedAt, endsAt: startedAt + PROGRESS_TOTAL_MS };
  scheduleDashboardAnimationEnd(key, PROGRESS_TOTAL_MS);
  return { html, staticBp };
}

function renderDashboardProgress(snapshot) {
  const breakdown = normalizedProgressBreakdown(snapshot);
  const animation = renderDashboardEventAnimation(breakdown.lastEvent, breakdown.goalBp);
  const staticSegments = renderStaticProgress(animation.staticBp ?? breakdown.currentBp, breakdown.goalBp);
  return `<div class="dashboard-progress-track" aria-hidden="true">${staticSegments}${animation.html}</div>`;
}

function bpIcon(size = 16, className = "bp-inline-icon") {
  return `<img class="${className}" src="${appPath("/assets/bloodpoint.png")}" alt="Bloodpoints" width="${size}" height="${size}">`;
}

function signedMetric(value, tone) {
  const number = Math.max(0, Math.trunc(Math.abs(Number(value) || 0)));
  const sign = tone === "negative" ? "-" : "+";
  return `<span class="metric-value is-${tone}">${sign}${fmt(number)}${bpIcon()}</span>`;
}

function phaseLabel(status) {
  const normalized = normalizeMatchStatus(status);
  if (normalized === MATCH_STATUS_PENDING_BONUSES) return "Bonos pendientes";
  if (normalized === MATCH_STATUS_PENDING_PENALTIES) return "Penalizaciones pendientes";
  return "Completa";
}

function lastEventLabel(event) {
  if (!event) return "";
  const delta = Number(event.deltaBp || 0);
  const tone = delta < 0 ? "negative" : "positive";
  const amount = signedMetric(Math.abs(delta), tone);
  const source = String(event.source || event.kind || "").toLowerCase();
  if (source === "match_bonus") return `<span class="last-event-copy">Bonos de partida ${amount}</span>`;
  if (source === "match_penalty" && Number(event.totalBp) > 0) return `<span class="last-event-copy">Partida completada ${signedMetric(event.totalBp, "positive")}</span>`;
  if (!delta) return "";
  if (source === "match_penalty") return `<span class="last-event-copy">Penalizaci&oacute;n ${amount}</span>`;
  if (source === "donation") return `<span class="last-event-copy">${escapeHtml(event.label || "Donaci&oacute;n")} ${delta < 0 ? "rest&oacute;" : "sum&oacute;"} ${amount}</span>`;
  return `<span class="last-event-copy">Partida ${amount}</span>`;
}

function renderDashboardLastEvent(snapshot) {
  const event = normalizedProgressBreakdown(snapshot).lastEvent;
  return `<div class="dashboard-last-event">${lastEventLabel(event) || ""}</div>`;
}

function createLocalProgressEvent(match, previousCurrentBp) {
  if (!match) return null;
  const status = normalizeMatchStatus(match.bonusStatus);
  const before = status === MATCH_STATUS_PENDING_BONUSES ? Math.max(0, Number(match.progressBefore) || 0) : Math.max(0, Number(previousCurrentBp) || 0);
  const after = Math.max(0, Number(match.progressAfter) || 0);
  const delta = after - before;
  if (!delta) return null;
  let source = "match";
  let label = `Partida ${match.matchNumber}`;
  let createdAt = match.createdAt || Date.now();
  let segments = [{ type: "base", bp: Math.abs(Number(match.baseBp) || delta) }];
  if (status === MATCH_STATUS_PENDING_PENALTIES) {
    source = "match_bonus";
    label = "Bonos";
    createdAt = match.bonusesSubmittedAt || createdAt;
    segments = [{ type: "bonus", bp: Math.abs(delta) }];
  } else if (status === MATCH_STATUS_COMPLETE && delta < 0) {
    source = "match_penalty";
    label = "Penalizaciones";
    createdAt = match.penaltiesSubmittedAt || createdAt;
    segments = [{ type: "subtract", bp: Math.abs(delta) }];
  }
  return { id: match.penaltyIdempotencyKey || match.bonusIdempotencyKey || match.idempotencyKey || match.id || Date.now(), kind: source, source, action: delta < 0 ? "subtract" : "add", deltaBp: delta, progressBefore: before, progressAfter: after, createdAt, label, detail: match.killerName || "", totalBp: Math.max(0, Number(match.totalBp) || 0), segments };
}

function withLocalProgressBreakdown(snapshot, currentBp, event) {
  const breakdown = snapshot.progressBreakdown || {};
  queueDashboardProgressEvent(event);
  return {
    ...breakdown,
    currentBp,
    goalBp: Math.max(1, Number(snapshot.challenge && snapshot.challenge.goalBp) || Number(breakdown.goalBp) || 1),
    lastEvent: event || breakdown.lastEvent || null
  };
}

function isSyncing() {
  return state.pendingRequests.size > 0;
}

async function api(path, options = {}) {
  const response = await fetch(appPath(path), {
    credentials: "include",
    cache: "no-store",
    ...options,
    headers: { ...(options.headers || {}) }
  });
  const data = await response.json().catch(() => null);
  if (!response.ok || (data && data.ok === false)) throw new Error((data && data.error) || `HTTP ${response.status}`);
  return data;
}

function setSnapshot(snapshot) {
  if (!snapshot) return;
  if (snapshot.pendingMatch && state.completedMatchIds.has(Number(snapshot.pendingMatch.id))) return;
  const previousSelectedKillerId = state.selectedKillerId;
  const event = snapshot.progressBreakdown && snapshot.progressBreakdown.lastEvent;
  if (!state.dashboardHydrated) {
    state.dashboardLastAnimatedEventKey = eventKey(event);
    state.dashboardLastAnimatedEventSignature = eventSignature(event);
    state.dashboardHydrated = true;
  } else queueDashboardProgressEvent(event);
  state.snapshot = snapshot;
  preloadKillerImages(snapshot.config);
  if (snapshot.pendingMatch) {
    state.selectedKillerId = snapshot.pendingMatch.killerId;
    state.resultStep = normalizeMatchStatus(snapshot.pendingMatch.bonusStatus) === MATCH_STATUS_PENDING_PENALTIES ? "penalties" : "bonuses";
  } else if (!state.selectedKillerId && snapshot.config && snapshot.config.selectedKillerId) {
    state.selectedKillerId = snapshot.config.selectedKillerId;
  }
  if (state.selectedKillerId && state.selectedKillerId !== previousSelectedKillerId && state.ws && state.ws.readyState === WebSocket.OPEN) publishOverlayKiller(selectedKiller());
  render();
}

function matchToHistoryRow(match, status) {
  return {
    id: match.id,
    match_number: match.matchNumber,
    killer_id: match.killerId,
    killer_name: match.killerName,
    base_bp: match.baseBp,
    killer_bonus_bp: match.killerBonusBp || 0,
    general_bonus_bp: match.generalBonusBp || 0,
    penalty_bp: match.penaltyBp || 0,
    total_bp: match.totalBp,
    progress_before: match.progressBefore,
    progress_after: match.progressAfter,
    bonuses_json: JSON.stringify(match.bonuses || { killer: [], general: [] }),
    penalties_json: JSON.stringify(match.penalties || {}),
    bonus_status: status || match.bonusStatus || MATCH_STATUS_COMPLETE,
    bonuses_submitted_at: match.bonusesSubmittedAt || null,
    penalties_submitted_at: match.penaltiesSubmittedAt || null,
    idempotency_key: match.idempotencyKey || match.idempotency_key || "",
    bonus_idempotency_key: match.bonusIdempotencyKey || match.bonus_idempotency_key || "",
    penalty_idempotency_key: match.penaltyIdempotencyKey || match.penalty_idempotency_key || "",
    optimistic: !!match.optimistic,
    created_at: match.createdAt || Date.now()
  };
}

function updateLocalMatchSnapshot(match) {
  const snapshot = state.snapshot;
  if (!snapshot || !match) return render();
  const status = normalizeMatchStatus(match.bonusStatus);
  if (status === MATCH_STATUS_COMPLETE) state.completedMatchIds.add(Number(match.id));
  const history = snapshot.history || { matches: [], modifiers: [] };
  const matches = Array.isArray(history.matches) ? [...history.matches] : [];
  const matchId = Number(match.id);
  const keys = [match.idempotencyKey || match.idempotency_key || "", match.bonusIdempotencyKey || match.bonus_idempotency_key || "", match.penaltyIdempotencyKey || match.penalty_idempotency_key || ""].filter(Boolean);
  const existingIndex = matches.findIndex((item) => Number(item.id) === matchId || keys.some((key) => item.idempotency_key === key || item.bonus_idempotency_key === key || item.penalty_idempotency_key === key));
  const row = matchToHistoryRow(match, status);
  if (existingIndex >= 0) matches[existingIndex] = row;
  else matches.unshift(row);
  const previousCurrentBp = Math.max(0, Number(snapshot.challenge && snapshot.challenge.currentBp) || 0);
  const nextCurrentBp = Math.max(0, Number(match.progressAfter) || 0);
  const progressEvent = createLocalProgressEvent(match, previousCurrentBp);
  state.snapshot = {
    ...snapshot,
    challenge: { ...snapshot.challenge, currentBp: nextCurrentBp, updatedAt: Date.now() },
    progressBreakdown: withLocalProgressBreakdown(snapshot, nextCurrentBp, progressEvent),
    pendingMatch: status === MATCH_STATUS_COMPLETE ? null : {
      id: match.id,
      matchNumber: match.matchNumber,
      killerId: match.killerId,
      killerName: match.killerName,
      baseBp: match.baseBp,
      killerBonusBp: match.killerBonusBp || 0,
      generalBonusBp: match.generalBonusBp || 0,
      penaltyBp: match.penaltyBp || 0,
      progressBefore: match.progressBefore,
      progressAfter: match.progressAfter,
      bonusStatus: status,
      createdAt: match.createdAt || Date.now(),
      bonusesSubmittedAt: match.bonusesSubmittedAt || null,
      penaltiesSubmittedAt: match.penaltiesSubmittedAt || null,
      idempotencyKey: match.idempotencyKey || match.idempotency_key || "",
      bonusIdempotencyKey: match.bonusIdempotencyKey || match.bonus_idempotency_key || "",
      penaltyIdempotencyKey: match.penaltyIdempotencyKey || match.penalty_idempotency_key || ""
    },
    history: { ...history, matches: matches.slice(0, 80) }
  };
  render();
}

function serializeCurrentBonuses(killer) {
  const killerBonuses = (killer && killer.bonuses || []).filter((bonus) => Number(state.killerCounts[bonus.id]) > 0).map((bonus) => ({ id: bonus.id, scope: "killer", text: bonus.text, bp: bonus.bp, count: Number(state.killerCounts[bonus.id]) || 0, totalBp: (Number(state.killerCounts[bonus.id]) || 0) * (Number(bonus.bp) || 0) }));
  const general = state.snapshot && state.snapshot.config ? state.snapshot.config.generalBonuses : [];
  const generalBonuses = (general || []).filter((bonus) => Number(state.generalCounts[bonus.id]) > 0).map((bonus) => ({ id: bonus.id, scope: "general", text: bonus.text, bp: bonus.bp, count: Number(state.generalCounts[bonus.id]) || 0, totalBp: (Number(state.generalCounts[bonus.id]) || 0) * (Number(bonus.bp) || 0) }));
  return { killer: killerBonuses, general: generalBonuses };
}

function serializeCurrentPenalties() {
  const items = MATCH_PENALTY_ITEMS.filter((item) => Number(state.penaltyCounts[item.id]) > 0).map((item) => ({ id: item.id, text: item.text, bp: item.bp, count: Number(state.penaltyCounts[item.id]) || 0, totalBp: (Number(state.penaltyCounts[item.id]) || 0) * item.bp }));
  return {
    items,
    hooksCount: state.hooksCount,
    hooksPenaltyBp: Math.max(0, 12 - state.hooksCount) * 1000,
    gensRepaired: state.gensCount,
    gensPenaltyBp: state.gensCount * 2000,
    escapesCount: state.escapesCount,
    escapesPenaltyBp: state.escapesCount * 2000
  };
}

function applyOptimisticMatchBase(killer, baseBp, idempotencyKey) {
  const snapshot = state.snapshot;
  if (!snapshot || !killer) return null;
  const before = Math.max(0, Number(snapshot.challenge.currentBp) || 0);
  const after = Math.max(0, before + baseBp);
  const matches = (snapshot.history && Array.isArray(snapshot.history.matches)) ? snapshot.history.matches : [];
  const maxNumber = matches.reduce((max, item) => Math.max(max, Number(item.match_number) || 0), 0);
  const now = Date.now();
  const match = { id: nextOptimisticId(), matchNumber: maxNumber + 1, killerId: killer.id, killerName: killer.name, baseBp, killerBonusBp: 0, generalBonusBp: 0, penaltyBp: 0, totalBp: baseBp, progressBefore: before, progressAfter: after, bonuses: { killer: [], general: [] }, penalties: serializeCurrentPenalties(), bonusStatus: MATCH_STATUS_PENDING_BONUSES, createdAt: now, idempotencyKey, optimistic: true };
  updateLocalMatchSnapshot(match);
  return match;
}

function applyOptimisticMatchBonuses(useBonuses, bonusIdempotencyKey = "") {
  const pending = state.snapshot && state.snapshot.pendingMatch;
  const killer = selectedKiller();
  if (!pending) return null;
  const totals = currentTotals();
  const bonusBp = useBonuses ? totals.killerBonus + totals.generalBonus : 0;
  const bonuses = useBonuses ? serializeCurrentBonuses(killer) : { killer: [], general: [] };
  const match = {
    id: pending.id,
    matchNumber: pending.matchNumber,
    killerId: pending.killerId,
    killerName: pending.killerName,
    baseBp: pending.baseBp,
    killerBonusBp: useBonuses ? totals.killerBonus : 0,
    generalBonusBp: useBonuses ? totals.generalBonus : 0,
    penaltyBp: 0,
    totalBp: pending.baseBp + bonusBp,
    progressBefore: pending.progressBefore,
    progressAfter: Math.max(0, (Number(state.snapshot.challenge.currentBp) || 0) + bonusBp),
    bonuses,
    penalties: { items: [], hooksCount: 0, hooksPenaltyBp: 0, gensRepaired: 0, gensPenaltyBp: 0, escapesCount: 0, escapesPenaltyBp: 0 },
    bonusStatus: MATCH_STATUS_PENDING_PENALTIES,
    createdAt: pending.createdAt || Date.now(),
    bonusesSubmittedAt: Date.now(),
    idempotencyKey: pending.idempotencyKey || "",
    bonusIdempotencyKey,
    optimistic: true
  };
  updateLocalMatchSnapshot(match);
  return match;
}

function applyOptimisticMatchPenalties(usePenalties, penaltyIdempotencyKey = "") {
  const pending = state.snapshot && state.snapshot.pendingMatch;
  if (!pending) return null;
  const totals = currentTotals();
  const penaltyBp = usePenalties ? totals.penalty : 0;
  const match = {
    id: pending.id,
    matchNumber: pending.matchNumber,
    killerId: pending.killerId,
    killerName: pending.killerName,
    baseBp: pending.baseBp,
    killerBonusBp: pending.killerBonusBp || 0,
    generalBonusBp: pending.generalBonusBp || 0,
    penaltyBp,
    totalBp: pending.baseBp + (pending.killerBonusBp || 0) + (pending.generalBonusBp || 0) - penaltyBp,
    progressBefore: pending.progressBefore,
    progressAfter: Math.max(0, (Number(state.snapshot.challenge.currentBp) || 0) - penaltyBp),
    bonuses: parseJsonObject(pending.bonuses_json, { killer: [], general: [] }),
    penalties: usePenalties ? serializeCurrentPenalties() : { items: [], hooksCount: 0, hooksPenaltyBp: 0, gensRepaired: 0, gensPenaltyBp: 0, escapesCount: 0, escapesPenaltyBp: 0 },
    bonusStatus: MATCH_STATUS_COMPLETE,
    createdAt: pending.createdAt || Date.now(),
    bonusesSubmittedAt: pending.bonusesSubmittedAt || Date.now(),
    penaltiesSubmittedAt: Date.now(),
    idempotencyKey: pending.idempotencyKey || "",
    bonusIdempotencyKey: pending.bonusIdempotencyKey || "",
    penaltyIdempotencyKey,
    optimistic: true
  };
  updateLocalMatchSnapshot(match);
  return match;
}
async function load() {
  try {
    const data = await api("/api/me");
    setSnapshot(data);
    await refreshMainClient();
    connectLive();
    startStreamlabsSocket();
  } catch (error) {
    state.error = String(error.message || error);
    render();
  }
}

async function refreshMainClient() {
  const data = await api(`/api/main-client?clientKey=${encodeURIComponent(state.clientKey)}`);
  state.isMain = !!data.isMain;
}

async function becomeMain() {
  const data = await api("/api/main-client", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ clientKey: state.clientKey })
  });
  state.isMain = !!data.isMain;
  connectLive();
  startStreamlabsSocket();
  render();
}

function wsUrl(path) {
  const url = new URL(path, window.location.href);
  url.protocol = url.protocol === "https:" ? "wss:" : "ws:";
  return url.toString();
}

function connectLive() {
  if (!state.isMain) return;
  if (state.ws && state.ws.readyState <= 1) return;
  const url = appPath(`/api/live?role=dashboard&clientKey=${encodeURIComponent(state.clientKey)}&clientBuild=${encodeURIComponent(CLIENT_BUILD)}`);
  const ws = new WebSocket(wsUrl(url));
  state.ws = ws;
  ws.addEventListener("open", () => publishOverlayKiller(selectedKiller()));
  ws.addEventListener("message", (event) => {
    const data = JSON.parse(String(event.data || "{}"));
    if (data.type === "snapshot" && data.snapshot) setSnapshot(data.snapshot);
    if (data.type === "main_client_updated") refreshMainClient().then(render).catch(() => {});
  });
  ws.addEventListener("close", () => {
    if (state.ws === ws) state.ws = null;
    setTimeout(connectLive, 1500);
  });
}

function findKiller(config, killerId) {
  return config && config.killers ? config.killers.find((killer) => killer.id === killerId) : null;
}

function killerImageSrc(killer) {
  const order = Number(killer && killer.order);
  if (!Number.isFinite(order) || order <= 0) return "";
  return appPath(`/assets/killers/K${String(Math.trunc(order)).padStart(2, "0")}.png`);
}

function preloadKillerImages(config) {
  if (typeof Image === "undefined" || !config || !Array.isArray(config.killers)) return;
  config.killers.forEach((killer) => {
    const src = killerImageSrc(killer);
    if (!src || preloadedKillerImages.has(src)) return;
    preloadedKillerImages.add(src);
    const image = new Image();
    image.decoding = "async";
    image.loading = "eager";
    image.src = src;
  });
}

function renderKillerMedia(killer, className, fallbackName = "") {
  const name = (killer && killer.name) || fallbackName || "Killer";
  const src = killerImageSrc(killer);
  return `<div class="killer-media ${className}">${src ? `<img src="${escapeAttr(src)}" alt="${escapeAttr(name)}" loading="eager" decoding="async" onerror="this.style.display='none'">` : ""}<span class="killer-media-fallback"></span></div>`;
}

function renderMatchKillerHero(killer) {
  if (!killer) return `<div class="match-killer-slot is-empty"><span>Elige killer</span></div>`;
  return `<div class="match-killer-slot">${renderKillerMedia(killer, "match-killer-media")}<div class="match-killer-name">${escapeHtml(killer.name)}</div></div>`;
}

function selectedKiller() {
  const snapshot = state.snapshot;
  const config = snapshot && snapshot.config;
  const pending = snapshot && snapshot.pendingMatch;
  return findKiller(config, pending ? pending.killerId : state.selectedKillerId);
}

function publicOverlayKiller(killer) {
  if (!killer) return null;
  return {
    id: String(killer.id || ""),
    name: String(killer.name || ""),
    order: Number(killer.order) || 0,
    imageSrc: killerImageSrc(killer),
    bonuses: Array.isArray(killer.bonuses) ? killer.bonuses.map((bonus) => ({
      id: String(bonus.id || ""),
      text: String(bonus.text || bonus.name || ""),
      bp: Number(bonus.bp) || 0
    })) : []
  };
}

function publishOverlayKiller(killer) {
  const payload = { type: "overlay_killer", killer: publicOverlayKiller(killer) };
  fetch(appPath("/api/overlay-killer"), {
    method: "POST",
    credentials: "include",
    cache: "no-store",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ killer: payload.killer })
  }).catch(() => {});
}

function overlayResultItems(items) {
  return (Array.isArray(items) ? items : []).map((item) => ({
    id: String(item && item.id || ""),
    text: String(item && item.text || ""),
    count: Math.max(0, Math.trunc(Number(item && item.count) || 0)),
    totalBp: Math.max(0, Math.trunc(Number(item && item.totalBp) || 0))
  })).filter((item) => item.text || item.totalBp > 0 || item.count > 0);
}

function buildOverlayPenaltyItems(penalties) {
  const data = penalties || {};
  const items = overlayResultItems(data.items || []);
  if (Number(data.hooksPenaltyBp) > 0) items.push({ id: "hooks", text: "Cantidad de hooks: " + Math.max(0, Math.trunc(Number(data.hooksCount) || 0)), count: 1, totalBp: Math.max(0, Math.trunc(Number(data.hooksPenaltyBp) || 0)) });
  if (Number(data.gensPenaltyBp) > 0) items.push({ id: "gens", text: "Generadores reparados: " + Math.max(0, Math.trunc(Number(data.gensRepaired) || 0)), count: 1, totalBp: Math.max(0, Math.trunc(Number(data.gensPenaltyBp) || 0)) });
  if (Number(data.escapesPenaltyBp) > 0) items.push({ id: "escapes", text: "Escapes: " + Math.max(0, Math.trunc(Number(data.escapesCount) || 0)), count: 1, totalBp: Math.max(0, Math.trunc(Number(data.escapesPenaltyBp) || 0)) });
  return items;
}

function buildOverlayResultBasePayload(killer, baseBp) {
  return { phase: "base", title: "Bloodpoints de la partida", killerName: killer && killer.name ? String(killer.name) : "", amountBp: Math.max(0, Math.trunc(Number(baseBp) || 0)), createdAt: Date.now() };
}

function buildOverlayResultBonusesPayload(killer, useBonuses) {
  const bonuses = useBonuses ? serializeCurrentBonuses(killer) : { killer: [], general: [] };
  return { phase: "bonuses", title: "Bonos aplicados", killerName: killer && killer.name ? String(killer.name) : "", killerItems: overlayResultItems(bonuses.killer), generalItems: overlayResultItems(bonuses.general), createdAt: Date.now() };
}

function buildOverlayResultPenaltiesPayload(pending, usePenalties) {
  const penalties = usePenalties ? serializeCurrentPenalties() : { items: [], hooksCount: 0, hooksPenaltyBp: 0, gensRepaired: 0, gensPenaltyBp: 0, escapesCount: 0, escapesPenaltyBp: 0 };
  return { phase: "penalties", title: "Penalizaciones aplicadas", killerName: pending && pending.killerName ? String(pending.killerName) : "", penaltyItems: buildOverlayPenaltyItems(penalties), hideAfterMs: 10000, createdAt: Date.now() };
}

function publishOverlayResult(result) {
  fetch(appPath("/api/overlay-result"), {
    method: "POST",
    credentials: "include",
    cache: "no-store",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ result: result || null })
  }).catch(() => {});
}

function bonusTotal(items, counts) {
  return (items || []).reduce((sum, item) => sum + (Math.max(0, Number(counts[item.id]) || 0) * (Number(item.bp) || 0)), 0);
}

function sanitizedCounts(counts) {
  return Object.fromEntries(Object.entries(counts || {}).map(([id, value]) => [id, Math.max(0, Math.trunc(Number(value) || 0))]).filter(([, value]) => value > 0));
}

function penaltyItemTotal() {
  return MATCH_PENALTY_ITEMS.reduce((sum, item) => sum + (Math.max(0, Number(state.penaltyCounts[item.id]) || 0) * item.bp), 0);
}

function penaltyHooksTotal() {
  return Math.max(0, 12 - Math.max(0, Math.min(12, Number(state.hooksCount) || 0))) * 1000;
}

function penaltyGensTotal() {
  return Math.max(0, Math.min(5, Number(state.gensCount) || 0)) * 2000;
}

function penaltyEscapesTotal() {
  return Math.max(0, Math.min(5, Number(state.escapesCount) || 0)) * 2000;
}

function clamp(value, min, max) {
  return Math.max(min, Math.min(max, Number(value) || 0));
}

function normalizeOverlayLayout(value) {
  const source = value && typeof value === "object" ? value : {};
  return Object.fromEntries(Object.entries(OVERLAY_LAYOUT_DEFAULT).map(([key, fallback]) => {
    const item = source[key] && typeof source[key] === "object" ? source[key] : {};
    const entry = {
      x: Math.round(clamp(Object.prototype.hasOwnProperty.call(item, "x") ? item.x : fallback.x, -600, OVERLAY_EDITOR_WIDTH)),
      y: Math.round(clamp(Object.prototype.hasOwnProperty.call(item, "y") ? item.y : fallback.y, -400, OVERLAY_EDITOR_HEIGHT)),
      scale: Math.round(clamp(Object.prototype.hasOwnProperty.call(item, "scale") ? item.scale : fallback.scale || 1, .5, 1.8) * 100) / 100
    };
    if (Object.prototype.hasOwnProperty.call(fallback, "side")) entry.side = String(item.side || fallback.side) === "right" ? "right" : "left";
    return [key, entry];
  }));
}

function overlayLayoutFromConfig(config) {
  return normalizeOverlayLayout(config && config.overlayLayout);
}

function overlayEditorFocusKey() {
  return OVERLAY_EDITOR_PANELS[state.overlayEditorFocusKey] ? state.overlayEditorFocusKey : "bonusPanel";
}

function setOverlayEditorFocus(key) {
  if (!OVERLAY_EDITOR_PANELS[key]) return;
  state.overlayEditorFocusKey = key;
  if (state.overlayEditorOpen) updateOverlayEditorDom();
}

function renderOverlayEditorSummary(key, pos) {
  const meta = OVERLAY_EDITOR_PANELS[key];
  if (!meta || !pos) return "";
  return `<button class="overlay-editor-summary is-${escapeAttr(key)}" data-overlay-coord="${key}" type="button"><b>${escapeHtml(meta.label)}</b><span class="overlay-editor-coord-xy">(${fmt(pos.x)}, ${fmt(pos.y)})</span><span class="overlay-editor-coord-scale">${Math.round((Number(pos.scale) || 1) * 100)}%</span>${pos.side ? `<span class="overlay-editor-coord-side">${pos.side === "right" ? "Derecha" : "Izquierda"}</span>` : ""}</button>`;
}

function currentOverlayLayoutDraft() {
  if (!state.overlayLayoutDraft) state.overlayLayoutDraft = overlayLayoutFromConfig(state.snapshot && state.snapshot.config);
  const layout = normalizeOverlayLayout(state.overlayLayoutDraft);
  if (state.overlayEditorOpen && typeof document !== "undefined") {
    for (const key of Object.keys(OVERLAY_EDITOR_PANELS)) {
      const item = document.querySelector(`[data-overlay-drag="${key}"]`);
      if (!item || !layout[key]) continue;
      const styleX = parseFloat(String(item.style.getPropertyValue("--x") || "").replace("px", ""));
      const styleY = parseFloat(String(item.style.getPropertyValue("--y") || "").replace("px", ""));
      const styleScale = parseFloat(String(item.style.getPropertyValue("--scale") || ""));
      if (Number.isFinite(styleX)) layout[key].x = Math.round(clamp(styleX, -600, OVERLAY_EDITOR_WIDTH));
      if (Number.isFinite(styleY)) layout[key].y = Math.round(clamp(styleY, -400, OVERLAY_EDITOR_HEIGHT));
      if (Number.isFinite(styleScale)) layout[key].scale = Math.round(clamp(styleScale, .5, 1.8) * 100) / 100;
      if (Object.prototype.hasOwnProperty.call(layout[key], "side")) {
        const activeSideButton = item.querySelector("[data-action='toggle-overlay-side'].is-active");
        layout[key].side = (activeSideButton && activeSideButton.dataset.sideTarget || item.dataset.side) === "right" ? "right" : "left";
      }
    }
  }
  state.overlayLayoutDraft = layout;
  return layout;
}

function setOverlayPanelSide(key, side) {
  if (!OVERLAY_EDITOR_PANELS[key]) return;
  const layout = currentOverlayLayoutDraft();
  if (!layout[key] || !Object.prototype.hasOwnProperty.call(layout[key], "side")) return;
  layout[key] = { ...layout[key], side: side === "right" ? "right" : "left" };
  state.overlayLayoutDraft = normalizeOverlayLayout(layout);
  updateOverlayEditorDom();
}


function currentTotals() {
  const snapshot = state.snapshot;
  const killer = selectedKiller();
  const general = snapshot && snapshot.config ? snapshot.config.generalBonuses : [];
  const pending = snapshot && snapshot.pendingMatch;
  const base = pending ? Math.max(0, Number(pending.baseBp) || 0) : Math.max(0, Number(state.resultBaseBp) || 0);
  const killerBonus = bonusTotal(killer ? killer.bonuses : [], state.killerCounts);
  const generalBonus = bonusTotal(general, state.generalCounts);
  const penaltyItems = penaltyItemTotal();
  const hooksPenalty = penaltyHooksTotal();
  const gensPenalty = penaltyGensTotal();
  const escapesPenalty = penaltyEscapesTotal();
  const penalty = penaltyItems + hooksPenalty + gensPenalty + escapesPenalty;
  return { base, killerBonus, generalBonus, bonus: killerBonus + generalBonus, penaltyItems, hooksPenalty, gensPenalty, escapesPenalty, penalty, total: base + killerBonus + generalBonus - penalty };
}

function visibleDonationRateList(config) {
  const byId = new Map(((config && config.donationRates) || []).map((rate) => [String(rate.id || ""), rate]));
  return DONATION_RATE_ORDER.map((id) => {
    const meta = DONATION_RATE_META[id];
    const rate = byId.get(id) || {};
    return { ...meta, ...rate, id, label: meta.label, shortLabel: meta.shortLabel, unit: meta.unit, enabled: true };
  });
}

function costPer100000(rate) {
  const amount = Number(rate && rate.amount);
  const bp = Number(rate && rate.bp);
  if (Number.isFinite(amount) && amount > 0 && Number.isFinite(bp) && bp > 0) return amount * 100000 / bp;
  return Number.isFinite(amount) && amount > 0 ? amount : 1;
}

function compactNumber(value) {
  const number = Number(value);
  if (!Number.isFinite(number)) return "";
  return Number.isInteger(number) ? String(number) : String(Math.round(number * 10000) / 10000);
}

function parseJsonObject(value, fallback = {}) {
  try {
    const parsed = value ? JSON.parse(value) : fallback;
    return parsed && typeof parsed === "object" ? parsed : fallback;
  } catch (_) {
    return fallback;
  }
}

function currentChallengeId() {
  return Number(state.snapshot && state.snapshot.challenge && state.snapshot.challenge.id) || 0;
}

function isCurrentChallengeRow(row) {
  return Number(row && row.challenge_id) === currentChallengeId();
}

function updateCount(bucket, id, delta) {
  if (bucket === "general") state.generalCounts[id] = Math.max(0, (Number(state.generalCounts[id]) || 0) + delta);
  else if (bucket === "penalty") state.penaltyCounts[id] = Math.max(0, (Number(state.penaltyCounts[id]) || 0) + delta);
  else state.killerCounts[id] = Math.max(0, (Number(state.killerCounts[id]) || 0) + delta);
  render();
}

function updateLimitedCount(kind, delta) {
  if (kind === "hooks") state.hooksCount = Math.max(0, Math.min(12, (Number(state.hooksCount) || 0) + delta));
  if (kind === "gens") state.gensCount = Math.max(0, Math.min(5, (Number(state.gensCount) || 0) + delta));
  if (kind === "escapes") state.escapesCount = Math.max(0, Math.min(5, (Number(state.escapesCount) || 0) + delta));
  render();
}

function resetCounts() {
  state.killerCounts = {};
  state.generalCounts = {};
  state.penaltyCounts = {};
  state.hooksCount = 0;
  state.gensCount = 0;
  state.escapesCount = 0;
  render();
}

async function startMatchResult() {
  if (!state.selectedKillerId) return setError("Selecciona un killer.");
  if (!Number.isFinite(Number(state.resultBaseBp)) || Number(state.resultBaseBp) < 0 || state.resultBaseBp === "") return setError("BP de partida invalido.");
  if (state.pendingRequests.has("match-base")) return;
  state.pendingRequests.add("match-base");
  const killer = selectedKiller();
  const baseBp = Math.trunc(Number(state.resultBaseBp));
  const previousSnapshot = cloneSnapshot();
  const idempotencyKey = createIdempotencyKey("match-base");
  const optimistic = applyOptimisticMatchBase(killer, baseBp, idempotencyKey);
  state.resultBaseBp = "";
  state.resultStep = "bonuses";
  state.resultModalOpen = true;
  publishOverlayResult(buildOverlayResultBasePayload(killer, baseBp));
  render();
  const request = api("/api/match", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ type: "start_match", killerId: state.selectedKillerId, baseBp, idempotencyKey })
  }).catch((error) => {
    if (previousSnapshot) state.snapshot = previousSnapshot;
    state.resultBaseBp = String(baseBp);
    state.resultStep = "base";
    state.resultModalOpen = true;
    render();
    throw error;
  });
  state.pendingBaseSync = request;
  let data;
  try {
    data = await request;
  } finally {
    if (state.pendingBaseSync === request) state.pendingBaseSync = null;
    state.pendingRequests.delete("match-base");
  }
  if (state.completedBaseIdempotencyKeys.has(idempotencyKey)) return;
  if (data.snapshot) setSnapshot(data.snapshot);
  else updateLocalMatchSnapshot({ ...data.match, idempotencyKey: optimistic && optimistic.idempotencyKey });
}

async function completePendingBonuses(useBonuses) {
  let pending = state.snapshot && state.snapshot.pendingMatch;
  if (!pending) return setError("No hay partida pendiente.");
  if (state.pendingRequests.has("match-bonuses")) return;
  state.pendingRequests.add("match-bonuses");
  const previousSnapshot = cloneSnapshot();
  const killerBonusCounts = useBonuses ? sanitizedCounts(state.killerCounts) : {};
  const generalBonusCounts = useBonuses ? sanitizedCounts(state.generalCounts) : {};
  const idempotencyKey = createIdempotencyKey("match-bonuses");
  const baseIdempotencyKey = pending.idempotencyKey || "";
  if (baseIdempotencyKey) state.completedBaseIdempotencyKeys.add(baseIdempotencyKey);
  applyOptimisticMatchBonuses(useBonuses, idempotencyKey);
  state.resultStep = "penalties";
  publishOverlayResult(buildOverlayResultBonusesPayload(selectedKiller(), useBonuses));
  render();
  if (pending && Number(pending.id) < 0 && state.pendingBaseSync) {
    try {
      const baseData = await state.pendingBaseSync;
      if (baseData && baseData.match) pending = { ...pending, ...baseData.match };
    } catch (error) {
      if (baseIdempotencyKey) state.completedBaseIdempotencyKeys.delete(baseIdempotencyKey);
      if (previousSnapshot) state.snapshot = previousSnapshot;
      state.resultModalOpen = true;
      state.resultStep = "base";
      state.pendingRequests.delete("match-bonuses");
      render();
      throw error;
    }
  }
  try {
    if (!pending || Number(pending.id) < 0) throw new Error("La partida aun se esta sincronizando.");
    const data = await api("/api/match", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ type: "complete_bonuses", matchId: pending.id, killerBonusCounts, generalBonusCounts, idempotencyKey })
    });
    if (data.snapshot) setSnapshot(data.snapshot);
    else updateLocalMatchSnapshot(data.match);
  } catch (error) {
    if (baseIdempotencyKey) state.completedBaseIdempotencyKeys.delete(baseIdempotencyKey);
    if (previousSnapshot) state.snapshot = previousSnapshot;
    state.resultModalOpen = true;
    state.resultStep = "bonuses";
    state.killerCounts = killerBonusCounts;
    state.generalCounts = generalBonusCounts;
    render();
    throw error;
  } finally {
    state.pendingRequests.delete("match-bonuses");
  }
}

async function completePendingPenalties(usePenalties) {
  let pending = state.snapshot && state.snapshot.pendingMatch;
  if (!pending) return setError("No hay partida pendiente.");
  if (state.pendingRequests.has("match-penalties")) return;
  state.pendingRequests.add("match-penalties");
  const previousSnapshot = cloneSnapshot();
  const payload = usePenalties ? { penaltyCounts: { ...state.penaltyCounts }, hooksCount: state.hooksCount, gensRepaired: state.gensCount, escapesCount: state.escapesCount } : { penaltyCounts: {}, hooksCount: 0, gensRepaired: 0, escapesCount: 0 };
  const idempotencyKey = createIdempotencyKey("match-penalties");
  applyOptimisticMatchPenalties(usePenalties, idempotencyKey);
  publishOverlayResult(buildOverlayResultPenaltiesPayload(pending, usePenalties));
  state.selectedKillerId = "";
  publishOverlayKiller(null);
  state.resultModalOpen = false;
  state.resultStep = "base";
  state.resultBaseBp = "";
  state.killerCounts = {};
  state.generalCounts = {};
  state.penaltyCounts = {};
  state.hooksCount = 0;
  state.gensCount = 0;
  state.escapesCount = 0;
  render();
  try {
    if (!pending || Number(pending.id) < 0) throw new Error("La partida aun se esta sincronizando.");
    const data = await api("/api/match", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ type: "complete_penalties", matchId: pending.id, idempotencyKey, ...payload })
    });
    if (data.snapshot) setSnapshot(data.snapshot);
    else updateLocalMatchSnapshot(data.match);
  } catch (error) {
    if (previousSnapshot) state.snapshot = previousSnapshot;
    state.resultModalOpen = true;
    state.resultStep = "penalties";
    state.penaltyCounts = payload.penaltyCounts || {};
    state.hooksCount = payload.hooksCount || 0;
    state.gensCount = payload.gensRepaired || 0;
    state.escapesCount = payload.escapesCount || 0;
    render();
    throw error;
  } finally {
    state.pendingRequests.delete("match-penalties");
  }
}
async function saveGoal() {
  if (state.pendingRequests.has("save-goal")) return;
  const input = document.getElementById("goalInput");
  const goal = Number(input && input.value);
  if (!Number.isFinite(goal) || goal <= 0) return setError("Meta invalida.");
  state.configDraft = { ...(state.configDraft || {}), goalBp: Math.trunc(goal) };
  state.pendingRequests.add("save-goal");
  render();
  let saved = false;
  try {
    const data = await api("/api/state", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ type: "set_goal", goalBp: Math.trunc(goal) })
    });
    setSnapshot(data.snapshot);
    state.configDraft = { ...(state.configDraft || {}), goalBp: Math.trunc(goal) };
    saved = true;
    setSuccess("Meta guardada.");
  } finally {
    state.pendingRequests.delete("save-goal");
    if (saved && !state.pendingRequests.has("save-config")) state.configDraft = null;
    render();
  }
}


async function saveOverlayLayout(layout) {
  if (state.pendingRequests.has("save-overlay-layout")) return;
  const overlayLayout = normalizeOverlayLayout(layout || state.overlayLayoutDraft || currentOverlayLayoutDraft());
  state.pendingRequests.add("save-overlay-layout");
  try {
    const data = await api("/api/config", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ overlayLayout })
    });
    setSnapshot(data.snapshot);
    state.overlayLayoutDraft = overlayLayout;
    setSuccess("Layout del overlay guardado.");
  } finally {
    state.pendingRequests.delete("save-overlay-layout");
    render();
  }
}

async function saveDonationConfig() {
  if (state.pendingRequests.has("save-config")) return;
  const rates = [];
  for (const row of Array.from(document.querySelectorAll("[data-rate-row]"))) {
    const id = row.dataset.rateRow;
    const meta = DONATION_RATE_META[id];
    const amount = Number(row.querySelector("[data-rate-amount]").value);
    if (!meta || !Number.isFinite(amount) || amount <= 0) return setError("Precio de donacion invalido.");
    rates.push({ id, label: meta.label, unit: meta.unit, amount, bp: 100000, enabled: true });
  }
  const hiddenRates = ((state.snapshot && state.snapshot.config && state.snapshot.config.donationRates) || []).filter((rate) => !fixedDonationRateIds.has(String(rate.id || "")));
  const overlayTitleInput = document.getElementById("overlayTitleInput");
  const overlayTitle = String(overlayTitleInput && overlayTitleInput.value || "").trim() || "BloodpointGoal";
  state.configDraft = { ...(state.configDraft || {}), overlayTitle, rates };
  state.pendingRequests.add("save-config");
  render();
  let saved = false;
  try {
    const data = await api("/api/config", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ overlayTitle, donationRates: [...rates, ...hiddenRates] })
    });
    setSnapshot(data.snapshot);
    state.configDraft = { ...(state.configDraft || {}), overlayTitle, rates };
    saved = true;
    setSuccess("Configuracion guardada.");
  } finally {
    state.pendingRequests.delete("save-config");
    if (saved && !state.pendingRequests.has("save-goal")) state.configDraft = null;
    render();
  }
}

async function createManualDonation() {
  const type = document.getElementById("manualDonationType").value;
  const amount = Number(document.getElementById("manualDonationAmount").value);
  const donorName = document.getElementById("manualDonationDonor").value.trim() || "Manual";
  if (!Number.isFinite(amount) || amount <= 0) return setError("Cantidad de donacion invalida.");
  const data = await api("/api/donations", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ type: "create_manual", donationType: type, amount, donorName, donorLogin: donorName, source: "manual" })
  });
  setSnapshot(data.snapshot);
}

async function resolveDonation(id, action) {
  const data = await api("/api/donations", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ type: "resolve", pendingId: id, action })
  });
  setSnapshot(data.snapshot);
}

async function cancelDonation(id) {
  const data = await api("/api/donations", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ type: "cancel", pendingId: id })
  });
  setSnapshot(data.snapshot);
}

async function resetChallenge() {
  const data = await api("/api/reset", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ confirm: "RESET" })
  });
  state.resetConfirmOpen = false;
  state.selectedKillerId = "";
  publishOverlayKiller(null);
  state.resultModalOpen = false;
  state.resultStep = "base";
  resetCounts();
  setSnapshot(data.snapshot);
}

async function undoLast() {
  const data = await api("/api/undo", { method: "POST" });
  setSnapshot(data.snapshot);
}

function openEditMatch(matchId) {
  const match = state.snapshot && state.snapshot.history && state.snapshot.history.matches.find((item) => Number(item.id) === Number(matchId));
  if (!match) return setError("Partida no encontrada.");
  if (!isCurrentChallengeRow(match)) return setError("Solo se puede editar el reto actual.");
  state.editModalOpen = true;
  state.editKind = "match";
  state.editId = Number(match.id);
  state.editValues = {
    baseBp: String(Math.max(0, Number(match.base_bp) || 0)),
    killerBonusBp: String(Math.max(0, Number(match.killer_bonus_bp) || 0)),
    generalBonusBp: String(Math.max(0, Number(match.general_bonus_bp) || 0)),
    penaltyBp: String(Math.max(0, Number(match.penalty_bp) || 0))
  };
  render();
}

function openEditDonation(modifierId) {
  const modifier = state.snapshot && state.snapshot.history && state.snapshot.history.modifiers.find((item) => Number(item.id) === Number(modifierId));
  if (!modifier) return setError("Donacion no encontrada.");
  if (!isCurrentChallengeRow(modifier)) return setError("Solo se puede editar el reto actual.");
  state.editModalOpen = true;
  state.editKind = "donation";
  state.editId = Number(modifier.id);
  state.editValues = {
    donorName: modifier.donor_name || "",
    donationType: modifier.donation_type || "",
    amount: compactNumber(modifier.amount || 0),
    action: modifier.action === "subtract" ? "subtract" : "add",
    bpValue: String(Math.max(0, Number(modifier.bp_value) || 0))
  };
  render();
}

async function saveHistoryEdit() {
  if (!state.editModalOpen) return;
  const values = state.editValues || {};
  let body;
  if (state.editKind === "match") {
    const baseBp = Number(values.baseBp);
    const killerBonusBp = Number(values.killerBonusBp);
    const generalBonusBp = Number(values.generalBonusBp);
    const penaltyBp = Number(values.penaltyBp);
    if (![baseBp, killerBonusBp, generalBonusBp, penaltyBp].every((value) => Number.isFinite(value) && value >= 0)) return setError("Valores de partida invalidos.");
    body = { type: "edit_match", matchId: state.editId, baseBp: Math.trunc(baseBp), killerBonusBp: Math.trunc(killerBonusBp), generalBonusBp: Math.trunc(generalBonusBp), penaltyBp: Math.trunc(penaltyBp) };
  } else if (state.editKind === "donation") {
    const amount = Number(values.amount);
    const bpValue = Number(values.bpValue);
    if (!Number.isFinite(amount) || amount < 0 || !Number.isFinite(bpValue) || bpValue < 0) return setError("Valores de donacion invalidos.");
    body = { type: "edit_modifier", modifierId: state.editId, donorName: values.donorName, donationType: values.donationType, amount, action: values.action, bpValue: Math.trunc(bpValue) };
  } else return;

  const data = await api("/api/history", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(body)
  });
  state.editModalOpen = false;
  state.editKind = "";
  state.editId = 0;
  state.editValues = {};
  setSnapshot(data.snapshot);
  setSuccess("Historial actualizado.");
}

async function connectStreamlabs() {
  window.location.href = appPath("/auth/streamlabs/start?returnTo=/BloodpointGoal/");
}

function currentOverlayUrl() {
  const snapshot = state.snapshot;
  return snapshot ? `${window.location.origin}/BloodpointGoal/overlay/${encodeURIComponent(snapshot.user.login || "")}` : "";
}

async function copyOverlayUrl() {
  const value = currentOverlayUrl();
  if (!value) return setError("Overlay no disponible.");
  try {
    await navigator.clipboard.writeText(value);
  } catch (_) {
    const input = document.createElement("textarea");
    input.value = value;
    input.setAttribute("readonly", "");
    input.style.position = "fixed";
    input.style.opacity = "0";
    document.body.appendChild(input);
    input.select();
    document.execCommand("copy");
    input.remove();
  }
  setSuccess("Overlay copiado.");
}

function setError(message) {
  state.error = message;
  state.success = "";
  render();
  setTimeout(() => {
    if (state.error === message) {
      state.error = "";
      render();
    }
  }, 3500);
}

function setSuccess(message) {
  state.success = message;
  state.error = "";
  render();
  setTimeout(() => {
    if (state.success === message) {
      state.success = "";
      render();
    }
  }, 3500);
}

function shouldUseStreamlabsSocket() {
  const user = state.snapshot && state.snapshot.user;
  return !!(state.isMain && user && user.streamlabs && user.streamlabs.connected && window.io && !state.streamlabsLoading);
}

async function startStreamlabsSocket() {
  if (!shouldUseStreamlabsSocket()) return;
  if (state.streamlabsSocket && state.streamlabsSocket.connected) return;
  state.streamlabsLoading = true;
  try {
    const data = await api(`/api/streamlabs/socket-token?clientKey=${encodeURIComponent(state.clientKey)}&clientBuild=${encodeURIComponent(CLIENT_BUILD)}`);
    if (!data.ok || !data.socketToken) return;
    const socket = window.io("https://sockets.streamlabs.com", {
      query: { token: data.socketToken },
      transports: ["websocket"],
      reconnection: true,
      reconnectionDelay: 1500,
      reconnectionDelayMax: 20000,
      timeout: 20000
    });
    state.streamlabsSocket = socket;
    socket.on("event", (eventData) => {
      if (eventData && String(eventData.type || "").toLowerCase() === "donation") {
        api("/api/streamlabs/socket-sync", {
          method: "POST",
          headers: { "content-type": "application/json" },
          body: JSON.stringify({ clientKey: state.clientKey, clientBuild: CLIENT_BUILD })
        }).then((payload) => setSnapshot(payload.snapshot)).catch(() => {});
      }
    });
  } catch (_) {
  } finally {
    state.streamlabsLoading = false;
  }
}
function renderCountControl(bucket, id, count, minusDisabled = false) {
  return `<div class="stepper">
    <button data-action="count" data-bucket="${bucket}" data-id="${escapeAttr(id)}" data-delta="-1" ${minusDisabled ? "disabled" : ""}>-</button>
    <button data-action="count" data-bucket="${bucket}" data-id="${escapeAttr(id)}" data-delta="1">+</button>
  </div>`;
}

function renderAfkSecondsControl(count) {
  return `<input class="bonus-seconds-input" data-afk-seconds inputmode="numeric" value="${escapeAttr(count || 0)}" placeholder="Seg.">`;
}

function renderBonusRows(items, counts, bucket, tone = "positive") {
  if (!items || !items.length) return `<div class="empty-row">Sin elementos.</div>`;
  return items.map((bonus) => {
    const count = Number(counts[bonus.id]) || 0;
    const isAfkSeconds = bucket === "general" && bonus.id === GENERAL_AFK_BONUS_ID;
    const displayBp = isAfkSeconds ? (count * Number(bonus.bp || 0)) : bonus.bp;
    const amount = tone === "negative" ? `<strong class="amount-negative">-${fmt(displayBp)}${bpIcon(14)}</strong>` : `<strong class="amount-positive">+${fmt(displayBp)}${bpIcon(14)}</strong>`;
    return `<div class="bonus-row">
      <div class="bonus-count">${count}</div>
      <div class="bonus-text">${escapeHtml(bonus.text)} ${amount}</div>
      ${isAfkSeconds ? renderAfkSecondsControl(count) : renderCountControl(bucket, bonus.id, count, count <= 0)}
    </div>`;
  }).join("");
}

function renderPenaltySpecialRows() {
  return `<div class="bonus-row">
      <div class="bonus-count">${state.hooksCount}</div>
      <div class="bonus-text">Cantidad de hooks <strong class="amount-negative">-${fmt(Math.max(0, 12 - state.hooksCount) * 1000)}${bpIcon(14)}</strong></div>
      <div class="stepper"><button data-action="limited-count" data-kind="hooks" data-delta="-1" ${state.hooksCount <= 0 ? "disabled" : ""}>-</button><button data-action="limited-count" data-kind="hooks" data-delta="1" ${state.hooksCount >= 12 ? "disabled" : ""}>+</button></div>
    </div>
    <div class="bonus-row">
      <div class="bonus-count">${state.gensCount}</div>
      <div class="bonus-text">Generadores reparados <strong class="amount-negative">-${fmt(2000)}${bpIcon(14)}</strong></div>
      <div class="stepper"><button data-action="limited-count" data-kind="gens" data-delta="-1" ${state.gensCount <= 0 ? "disabled" : ""}>-</button><button data-action="limited-count" data-kind="gens" data-delta="1" ${state.gensCount >= 5 ? "disabled" : ""}>+</button></div>
    </div>
    <div class="bonus-row">
      <div class="bonus-count">${state.escapesCount}</div>
      <div class="bonus-text">Escapes <strong class="amount-negative">-${fmt(2000)}${bpIcon(14)}</strong></div>
      <div class="stepper"><button data-action="limited-count" data-kind="escapes" data-delta="-1" ${state.escapesCount <= 0 ? "disabled" : ""}>-</button><button data-action="limited-count" data-kind="escapes" data-delta="1" ${state.escapesCount >= 5 ? "disabled" : ""}>+</button></div>
    </div>`;
}

function renderBonusPreviewRows(items, tone = "positive") {
  if (!items || !items.length) return `<div class="empty-row">Selecciona un killer para ver sus bonos.</div>`;
  return items.map((bonus) => {
    const suffix = bonus.id === GENERAL_AFK_BONUS_ID ? "/seg" : "";
    return `<div class="bonus-row bonus-preview"><div class="bonus-text">${escapeHtml(bonus.text)} ${tone === "negative" ? `<strong class="amount-negative">-${fmt(bonus.bp)}${bpIcon(14)}</strong>` : `<strong class="amount-positive">+${fmt(bonus.bp)}${bpIcon(14)}${suffix}</strong>`}</div></div>`;
  }).join("");
}

function renderPenaltyPreviewPanel() {
  return `${renderBonusPreviewRows(MATCH_PENALTY_ITEMS, "negative")}
    <div class="bonus-row bonus-preview"><div class="bonus-text">Cantidad de hooks: por cada hook faltante <strong class="amount-negative">-1,000${bpIcon(14)}</strong></div></div>
    <div class="bonus-row bonus-preview"><div class="bonus-text">Generadores reparados: cada uno <strong class="amount-negative">-2,000${bpIcon(14)}</strong></div></div>
    <div class="bonus-row bonus-preview"><div class="bonus-text">Escapes: cada uno <strong class="amount-negative">-2,000${bpIcon(14)}</strong></div></div>`;
}

function renderHistoryMatchRows(matches, config, goalBp) {
  if (!matches || !matches.length) return `<div class="empty-row">Sin partidas.</div>`;
  return matches.map((match) => {
    const killer = findKiller(config, match.killer_id);
    const bonusBp = (Number(match.killer_bonus_bp) || 0) + (Number(match.general_bonus_bp) || 0);
    const penaltyBp = Number(match.penalty_bp) || 0;
    const status = normalizeMatchStatus(match.bonus_status);
    const pending = status !== MATCH_STATUS_COMPLETE ? ` (${escapeHtml(phaseLabel(status))})` : "";
    const editable = isCurrentChallengeRow(match);
    const totalTone = Number(match.total_bp) < 0 ? "negative" : "positive";
    return `<div class="history-row match-history-row is-${totalTone}">
      ${renderKillerMedia(killer, "history-killer-media", match.killer_name)}
      <div class="history-match-copy">
        <strong>Partida ${fmt(match.match_number)}${pending}${editable ? `<button class="mini-action" data-action="edit-match" data-id="${match.id}">Editar</button>` : ""}</strong>
        <span class="history-stats"><span>Base ${signedMetric(match.base_bp, "positive")}</span><span>Bonos ${signedMetric(bonusBp, "positive")}</span><span>Pen. ${signedMetric(penaltyBp, "negative")}</span><span class="history-total is-${totalTone}">Total ${signedMetric(Math.abs(Number(match.total_bp) || 0), totalTone)}</span></span>
        <em>${fmt(match.progress_after)} / ${fmt(goalBp)}</em>
      </div>
    </div>`;
  }).join("");
}

function renderHistoryDonationRows(modifiers, goalBp) {
  if (!modifiers || !modifiers.length) return `<div class="empty-row">Sin donaciones aplicadas.</div>`;
  return modifiers.map((modifier) => {
    const isSubtract = modifier.action === "subtract";
    const editable = isCurrentChallengeRow(modifier);
    return `<div class="history-row donation-history-row ${isSubtract ? "is-subtract" : "is-add"}">
      <strong><span>${escapeHtml(modifier.donor_name)}</span><b>${isSubtract ? "-" : "+"}${fmt(modifier.bp_value)}${bpIcon(16, "event-bp-icon")}</b></strong>
      <span>${escapeHtml(modifier.donation_type)} ${fmt(modifier.amount)}${editable ? `<button class="mini-action" data-action="edit-donation" data-id="${modifier.id}">Editar</button>` : ""}</span>
      <em>${fmt(modifier.progress_after)} / ${fmt(goalBp)}</em>
    </div>`;
  }).join("");
}

function renderKillerModal(config) {
  if (!state.killerModalOpen) return "";
  const search = state.killerSearch.toLowerCase();
  const killers = (config.killers || []).filter((killer) => killer.name.toLowerCase().includes(search));
  return `<div class="modal-backdrop" data-action="close-killer-modal">
    <div class="modal killer-modal" role="dialog" aria-modal="true">
      <div class="modal-head"><h2>Seleccionar killer</h2><button data-action="close-killer-modal">x</button></div>
      <input id="killerSearch" class="search-input" placeholder="Buscar killer" value="${escapeAttr(state.killerSearch)}" autofocus>
      <div class="killer-list">
        ${killers.map((killer) => `<button class="killer-option" data-action="select-killer" data-id="${escapeAttr(killer.id)}">${renderKillerMedia(killer, "killer-option-media")}<strong>${escapeHtml(killer.name)}</strong></button>`).join("")}
      </div>
    </div>
  </div>`;
}

function renderKillerOptions(config) {
  const search = state.killerSearch.toLowerCase();
  const killers = (config.killers || []).filter((killer) => killer.name.toLowerCase().includes(search));
  return killers.map((killer) => `<button class="killer-option" data-action="select-killer" data-id="${escapeAttr(killer.id)}">${renderKillerMedia(killer, "killer-option-media")}<strong>${escapeHtml(killer.name)}</strong></button>`).join("");
}

function updateKillerList() {
  const config = state.snapshot && state.snapshot.config;
  const list = document.querySelector(".killer-list");
  if (config && list) list.innerHTML = renderKillerOptions(config);
}

function renderEditModal() {
  if (!state.editModalOpen) return "";
  const values = state.editValues || {};
  if (state.editKind === "match") {
    const total = (Number(values.baseBp) || 0) + (Number(values.killerBonusBp) || 0) + (Number(values.generalBonusBp) || 0) - (Number(values.penaltyBp) || 0);
    return `<div class="modal-backdrop" data-action="close-edit-modal">
      <div class="modal edit-modal" role="dialog" aria-modal="true">
        <div class="modal-head"><h2>Editar partida</h2><button data-action="close-edit-modal">x</button></div>
        <div class="edit-grid">
          <label class="field"><span>BP partida</span><input data-edit-field="baseBp" inputmode="numeric" value="${escapeAttr(values.baseBp || "")}"></label>
          <label class="field"><span>Bonos killer</span><input data-edit-field="killerBonusBp" inputmode="numeric" value="${escapeAttr(values.killerBonusBp || "")}"></label>
          <label class="field"><span>Bonos generales</span><input data-edit-field="generalBonusBp" inputmode="numeric" value="${escapeAttr(values.generalBonusBp || "")}"></label>
          <label class="field"><span>Penalizaciones</span><input data-edit-field="penaltyBp" inputmode="numeric" value="${escapeAttr(values.penaltyBp || "")}"></label>
        </div>
        <div class="summary-strip modal-summary"><strong>Total ${signedMetric(Math.abs(total), total < 0 ? "negative" : "positive")}</strong><span>Recalcula historial posterior</span></div>
        <div class="modal-actions"><button data-action="close-edit-modal">Cancelar</button><button class="primary" data-action="save-history-edit">Guardar</button></div>
      </div>
    </div>`;
  }
  return `<div class="modal-backdrop" data-action="close-edit-modal">
    <div class="modal edit-modal" role="dialog" aria-modal="true">
      <div class="modal-head"><h2>Editar donacion</h2><button data-action="close-edit-modal">x</button></div>
      <div class="edit-grid">
        <label class="field"><span>Donador</span><input data-edit-field="donorName" value="${escapeAttr(values.donorName || "")}"></label>
        <label class="field"><span>Tipo</span><input data-edit-field="donationType" value="${escapeAttr(values.donationType || "")}"></label>
        <label class="field"><span>Cantidad</span><input data-edit-field="amount" inputmode="decimal" value="${escapeAttr(values.amount || "")}"></label>
        <label class="field"><span>Accion</span><select data-edit-field="action"><option value="add" ${values.action === "subtract" ? "" : "selected"}>Sumar</option><option value="subtract" ${values.action === "subtract" ? "selected" : ""}>Restar</option></select></label>
        <label class="field"><span>BP aplicados</span><input data-edit-field="bpValue" inputmode="numeric" value="${escapeAttr(values.bpValue || "")}"></label>
      </div>
      <div class="modal-actions"><button data-action="close-edit-modal">Cancelar</button><button class="primary" data-action="save-history-edit">Guardar</button></div>
    </div>
  </div>`;
}

function renderOverlayEditorModal() {
  if (!state.overlayEditorOpen) return "";
  const config = state.snapshot && state.snapshot.config || {};
  const layout = normalizeOverlayLayout(state.overlayLayoutDraft || overlayLayoutFromConfig(config));
  const panels = Object.entries(OVERLAY_EDITOR_PANELS).map(([key, meta]) => {
    const pos = layout[key] || OVERLAY_LAYOUT_DEFAULT[key];
    const sideButton = Object.prototype.hasOwnProperty.call(pos, "side") ? `<div class="overlay-side-controls" data-side-controls="${key}"><button class="overlay-side-toggle ${pos.side === "left" ? "is-active" : ""}" data-action="toggle-overlay-side" data-panel="${key}" data-side-target="left">Izquierda</button><button class="overlay-side-toggle ${pos.side === "right" ? "is-active" : ""}" data-action="toggle-overlay-side" data-panel="${key}" data-side-target="right">Derecha</button></div>` : "";
    const resizeHandles = ["nw", "ne", "sw", "se"].map((corner) => `<button class="overlay-resize-handle is-${corner}" data-overlay-resize="${key}" data-corner="${corner}" aria-label="Redimensionar ${escapeAttr(meta.label)} ${corner}"></button>`).join("");
    return `<div class="overlay-editor-item overlay-editor-${key} is-${escapeAttr(pos.side || "center")}" data-overlay-drag="${key}" data-side="${escapeAttr(pos.side || "")}" style="--x:${pos.x}px;--y:${pos.y}px;--w:${meta.width}px;--h:${meta.height}px;--scale:${pos.scale || 1}" role="button" tabindex="0"><strong>${escapeHtml(meta.label)}</strong>${sideButton}${resizeHandles}</div>`;
  }).join("");
  const focusKey = overlayEditorFocusKey();
  const focusSummary = renderOverlayEditorSummary(focusKey, layout[focusKey]);
  const coords = Object.entries(OVERLAY_EDITOR_PANELS).map(([key]) => renderOverlayEditorSummary(key, layout[key]).replace("overlay-editor-summary", "overlay-editor-coord-chip")).join("");
  return `<div class="modal-backdrop overlay-editor-backdrop" data-action="close-overlay-editor">
    <div class="modal overlay-editor-modal" role="dialog" aria-modal="true">
      <div class="modal-head"><h2>Editar overlay</h2><button data-action="close-overlay-editor">x</button></div>
      <div class="overlay-editor-tools"><span>Escenario 1920 x 1080</span><div class="overlay-editor-summary-wrap">${focusSummary}</div><button data-action="reset-overlay-layout">Reset posiciones</button></div>
      <div class="overlay-editor-stage-wrap">
        <div class="overlay-editor-stage" data-overlay-stage>${panels}</div>
      </div>
      <div class="overlay-editor-coords">${coords}</div>
      <div class="modal-actions"><button data-action="close-overlay-editor">Cancelar</button><button class="primary" data-action="save-overlay-layout" ${state.pendingRequests.has("save-overlay-layout") ? "disabled" : ""}>${actionLabel("save-overlay-layout", "Guardar layout")}</button></div>
    </div>
  </div>`;
}
function renderResetModal() {
  if (!state.resetConfirmOpen) return "";
  return `<div class="modal-backdrop" data-action="close-reset-modal">
    <div class="modal confirm-modal" role="dialog" aria-modal="true">
      <div class="modal-head"><h2>Resetear reto</h2><button data-action="close-reset-modal">x</button></div>
      <p class="modal-copy">Se reiniciara el progreso diario actual. El historial anterior se conserva.</p>
      <div class="modal-actions"><button data-action="close-reset-modal">Cancelar</button><button class="danger" data-action="confirm-reset-challenge">Reset</button></div>
    </div>
  </div>`;
}

function renderStepSummary(totals) {
  return `<div class="summary-strip modal-summary"><span>Base ${signedMetric(totals.base, "positive")}</span><span>Bonos ${signedMetric(totals.bonus, "positive")}</span><span>Penalizaciones ${signedMetric(totals.penalty, "negative")}</span><strong>Total ${signedMetric(Math.abs(totals.total), totals.total < 0 ? "negative" : "positive")}</strong></div>`;
}

function renderResultModal(config) {
  const snapshot = state.snapshot;
  const pending = snapshot && snapshot.pendingMatch;
  if (!state.resultModalOpen) return "";
  const killer = pending ? findKiller(config, pending.killerId) : selectedKiller();
  const totals = currentTotals();
  const step = pending ? (normalizeMatchStatus(pending.bonusStatus) === MATCH_STATUS_PENDING_PENALTIES ? "penalties" : "bonuses") : state.resultStep;
  const title = pending ? `Partida ${pending.matchNumber} - ${pending.killerName}` : (killer ? killer.name : "Resultado");

  if (step === "base") {
    return `<div class="modal-backdrop" data-action="close-result-modal">
      <div class="modal result-modal" role="dialog" aria-modal="true">
        <div class="modal-head"><h2>${escapeHtml(title)}</h2><button data-action="close-result-modal">x</button></div>
        <label class="field"><span>BP partida</span><input id="resultBaseBpInput" inputmode="numeric" value="${escapeAttr(state.resultBaseBp)}" placeholder="40,000" autofocus></label>
        <div class="modal-actions"><button class="primary" data-action="start-match-base">Enviar BP partida</button></div>
      </div>
    </div>`;
  }

  if (step === "bonuses") {
    return `<div class="modal-backdrop" data-action="close-result-modal">
      <div class="modal result-modal" role="dialog" aria-modal="true">
        <div class="modal-head"><h2>${escapeHtml(title)}</h2><button data-action="close-result-modal">x</button></div>
        ${renderStepSummary(totals)}
        <div class="modal-bonus-grid">
          <div><div class="panel-subhead"><h3>Bonos del killer</h3></div><div class="bonus-list modal-bonus-list">${renderBonusRows(killer ? killer.bonuses : [], state.killerCounts, "killer", "positive")}</div></div>
          <div><div class="panel-subhead"><h3>Bonos generales</h3></div><div class="bonus-list modal-bonus-list">${renderBonusRows(config.generalBonuses, state.generalCounts, "general", "positive")}</div></div>
        </div>
        <div class="modal-actions"><button data-action="complete-match-no-bonuses">Enviar sin bonos</button><button class="primary" data-action="complete-match-bonuses">Enviar bonos</button></div>
      </div>
    </div>`;
  }

  return `<div class="modal-backdrop" data-action="close-result-modal">
    <div class="modal result-modal" role="dialog" aria-modal="true">
      <div class="modal-head"><h2>${escapeHtml(title)}</h2><button data-action="close-result-modal">x</button></div>
      ${renderStepSummary(totals)}
      <div class="panel-subhead"><h3>Penalizaciones</h3></div>
      <div class="bonus-list modal-bonus-list">${renderBonusRows(MATCH_PENALTY_ITEMS, state.penaltyCounts, "penalty", "negative")}${renderPenaltySpecialRows()}</div>
      <div class="modal-actions"><button data-action="complete-match-no-penalties">Enviar sin penalizaciones</button><button class="primary" data-action="complete-match-penalties">Enviar penalizaciones</button></div>
    </div>
  </div>`;
}
function render() {
  const root = document.getElementById("app");
  const snapshot = state.snapshot;
  if (!snapshot) {
    root.innerHTML = `<main class="shell"><div class="loading-panel">${state.error ? escapeHtml(state.error) : "Cargando BloodpointGoal..."}</div></main>`;
    return;
  }
  const config = snapshot.config;
  const visibleDonationRates = visibleDonationRateList(config);
  const challenge = snapshot.challenge;
  const killer = selectedKiller();
  const pendingMatch = snapshot.pendingMatch;
  const overlayUrl = currentOverlayUrl();
  const canAddResults = !!(killer || pendingMatch);
  const historyTab = state.historyTab === "donations" ? "donations" : "matches";
  const modifierTab = state.modifierTab === "penalties" ? "penalties" : "bonuses";
  const pendingPhase = pendingMatch ? phaseLabel(pendingMatch.bonusStatus) : "";
  const draft = state.configDraft || {};
  const draftRates = new Map((draft.rates || []).map((rate) => [String(rate.id || ""), rate]));
  const displayGoal = draft.goalBp || challenge.goalBp;
  const displayOverlayTitle = Object.prototype.hasOwnProperty.call(draft, "overlayTitle") ? draft.overlayTitle : (config.overlayTitle || "BloodpointGoal");
  root.innerHTML = `<main class="shell">
    <header class="topbar">
      <div class="score-head"><div class="eyebrow">BloodpointGoal</div><h1>${fmt(challenge.currentBp)} / ${fmt(challenge.goalBp)} ${bpIcon(28, "bp-icon-title")}</h1></div>
      <div class="top-actions">
        ${isSyncing() ? `<span class="sync-pill">SYNC</span>` : ""}
        <span class="main-pill ${state.isMain ? "is-main" : ""}">${state.isMain ? "Principal" : "Vista"}</span>
        ${state.isMain ? "" : `<button data-action="become-main">Usar aqui</button>`}
        <button data-action="undo">Deshacer</button>
        <button class="danger" data-action="reset-challenge">Reset</button>
      </div>
    </header>
    <div class="dashboard-progress-wrap">${renderDashboardProgress(snapshot)}${renderDashboardLastEvent(snapshot)}</div>
    ${state.error ? `<div class="notice error">${escapeHtml(state.error)}</div>` : ""}
    ${state.success ? `<div class="notice success">${escapeHtml(state.success)}</div>` : ""}
    <section class="grid">
      <div class="layout-column layout-left">
      <div class="panel match-panel">
        <div class="match-actions">
          <button class="primary" data-action="open-result-modal" ${canAddResults ? "" : "disabled"}>${pendingMatch ? `Continuar ${escapeHtml(pendingPhase)}` : "A&ntilde;adir resultados"}</button>
          <button data-action="open-killer-modal" ${pendingMatch ? "disabled" : ""}>${killer ? "Cambiar killer" : "Elegir killer"}</button>
        </div>
        ${renderMatchKillerHero(killer)}
        <div class="panel-subhead"><h3>Bonos del killer</h3></div>
        <div class="bonus-list compact">${renderBonusPreviewRows(killer ? killer.bonuses : [])}</div>
      </div>
      <div class="panel config-panel compact-config-panel">
        <div class="panel-head"><h2>Configuracion</h2></div>
        <div class="overlay-title-row"><input id="overlayTitleInput" maxlength="40" value="${escapeAttr(displayOverlayTitle)}" placeholder="Titulo overlay"></div>
        <div class="goal-row"><input id="goalInput" inputmode="numeric" value="${displayGoal}"><button data-action="save-goal" ${state.pendingRequests.has("save-goal") ? "disabled" : ""}>${actionLabel("save-goal", "Guardar meta")}</button></div>
        <div class="rates-list compact-rates">${visibleDonationRates.map((rate) => { const draftRate = draftRates.get(String(rate.id)); const displayRate = draftRate ? { ...rate, ...draftRate } : rate; return `<div class="rate-row" data-rate-row="${escapeAttr(rate.id)}"><strong>${escapeHtml(rate.shortLabel)}</strong><span>100,000 =</span><input data-rate-amount inputmode="decimal" value="${escapeAttr(compactNumber(costPer100000(displayRate)))}"><em>${escapeHtml(rate.unit)}</em></div>`; }).join("")}</div>
        <button data-action="save-donation-config" ${state.pendingRequests.has("save-config") ? "disabled" : ""}>${actionLabel("save-config", "Guardar configuracion")}</button>
      </div>
      </div>
      <div class="layout-column layout-center">
      <div class="panel general-panel modifiers-panel">
        <div class="panel-head"><h2>Modificadores</h2></div>
        <div class="history-tabs modifier-tabs"><button class="history-tab ${modifierTab === "bonuses" ? "is-active" : ""}" data-action="modifier-tab" data-tab="bonuses">Bonos generales</button><button class="history-tab ${modifierTab === "penalties" ? "is-active" : ""}" data-action="modifier-tab" data-tab="penalties">Penalizaciones</button></div>
        <div class="bonus-list compact">${modifierTab === "penalties" ? renderPenaltyPreviewPanel() : renderBonusPreviewRows(config.generalBonuses, "positive")}</div>
      </div>
      </div>
      <div class="layout-column layout-right">
      <div class="panel history-panel">
        <div class="panel-head"><h2>Historial 7 dias</h2></div>
        <div class="history-tabs"><button class="history-tab ${historyTab === "matches" ? "is-active" : ""}" data-action="history-tab" data-tab="matches">Partidas</button><button class="history-tab ${historyTab === "donations" ? "is-active" : ""}" data-action="history-tab" data-tab="donations">Donaciones</button></div>
        <div class="history-list ${historyTab === "donations" ? "is-donations" : "is-matches"}">${historyTab === "donations" ? renderHistoryDonationRows(snapshot.history.modifiers, challenge.goalBp) : renderHistoryMatchRows(snapshot.history.matches, config, challenge.goalBp)}</div>
      </div>
      <div class="panel donations-panel">
        <div class="panel-head"><h2>Donaciones pendientes</h2><button data-action="connect-streamlabs">${snapshot.user.streamlabs.connected ? "Streamlabs OK" : "Conectar Streamlabs"}</button></div>
        <div class="pending-list">${(snapshot.pendingDonations || []).map((item) => `<div class="pending-row">
          <div><strong>${escapeHtml(item.donor_name)}</strong><span>${escapeHtml(item.donation_type)} ${fmt(item.amount)} = ${fmt(item.raw_bp_value)} ${bpIcon(14)}</span></div>
          <div class="pending-actions"><button data-action="resolve-donation" data-id="${item.id}" data-resolution="add">Sumar</button><button data-action="resolve-donation" data-id="${item.id}" data-resolution="subtract">Restar</button><button data-action="cancel-donation" data-id="${item.id}">Ignorar</button></div>
        </div>`).join("") || `<div class="empty-row">Sin pendientes.</div>`}</div>
        <div class="manual-donation">
          <select id="manualDonationType">${visibleDonationRates.map((rate) => `<option value="${escapeAttr(rate.id)}">${escapeHtml(rate.label)}</option>`).join("")}</select>
          <input id="manualDonationAmount" inputmode="decimal" placeholder="Cantidad">
          <input id="manualDonationDonor" placeholder="Donador">
          <button data-action="create-donation">Crear</button>
        </div>
      </div>
      <div class="panel overlay-panel">
        <div class="overlay-mini-panel">
          <div class="panel-subhead"><h3>Overlay</h3><div class="overlay-panel-actions"><button data-action="open-overlay-editor">Editar overlay</button><button data-action="copy-overlay">Copy</button></div></div>
          <button class="overlay-copy-value" data-action="copy-overlay" title="Copiar overlay"><code>${escapeHtml(overlayUrl)}</code></button>
        </div>
      </div>
      </div>
    </section>
    ${renderKillerModal(config)}
    ${renderResultModal(config)}
    ${renderOverlayEditorModal()}
    ${renderResetModal()}
    ${renderEditModal()}
  </main>`;
}

function escapeHtml(value) {
  return String(value ?? "").replace(/[&<>"']/g, (char) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[char]));
}

function escapeAttr(value) {
  return escapeHtml(value);
}

function handleEditFieldEvent(event) {
  const editField = event.target.dataset && event.target.dataset.editField;
  if (!editField) return false;
  const numericFields = new Set(["baseBp", "killerBonusBp", "generalBonusBp", "penaltyBp", "bpValue"]);
  state.editValues[editField] = numericFields.has(editField) ? event.target.value.replace(/[^0-9]/g, "") : event.target.value;
  return true;
}

function closeTopModal() {
  if (state.killerModalOpen) state.killerModalOpen = false;
  else if (state.editModalOpen) { state.editModalOpen = false; state.editKind = ""; state.editId = 0; state.editValues = {}; }
  else if (state.resetConfirmOpen) state.resetConfirmOpen = false;
  else if (state.resultModalOpen) { state.resultModalOpen = false; if (!state.snapshot || !state.snapshot.pendingMatch) state.resultStep = "base"; }
  render();
}

function submitResultStepShortcut() {
  const pending = state.snapshot && state.snapshot.pendingMatch;
  const step = pending ? (normalizeMatchStatus(pending.bonusStatus) === MATCH_STATUS_PENDING_PENALTIES ? "penalties" : "bonuses") : state.resultStep;
  if (step === "base") return startMatchResult().catch((error) => setError(error.message));
  if (step === "bonuses") return completePendingBonuses(true).catch((error) => setError(error.message));
  if (step === "penalties") return completePendingPenalties(true).catch((error) => setError(error.message));
}

function adjustFocusedCounter(delta) {
  const row = document.activeElement && document.activeElement.closest ? document.activeElement.closest(".bonus-row") : null;
  const button = row && row.querySelector(`[data-action="count"][data-delta="${delta}"], [data-action="limited-count"][data-delta="${delta}"]`);
  if (button && !button.disabled) button.click();
}

document.addEventListener("keydown", (event) => {
  const target = event.target;
  const isTyping = target && ["INPUT", "TEXTAREA", "SELECT"].includes(target.tagName);
  if (event.key === "Escape" && (state.resultModalOpen || state.killerModalOpen || state.editModalOpen || state.resetConfirmOpen)) { event.preventDefault(); closeTopModal(); return; }
  if (event.key === "Enter" && state.resultModalOpen && !isTyping) { event.preventDefault(); submitResultStepShortcut(); return; }
  if (!isTyping && event.key.toLowerCase() === "a") { event.preventDefault(); if (state.snapshot && (selectedKiller() || state.snapshot.pendingMatch)) { state.resultModalOpen = true; state.resultStep = state.snapshot.pendingMatch ? (normalizeMatchStatus(state.snapshot.pendingMatch.bonusStatus) === MATCH_STATUS_PENDING_PENALTIES ? "penalties" : "bonuses") : "base"; render(); } }
  if (!isTyping && event.code === "Space") { event.preventDefault(); if (!(state.snapshot && state.snapshot.pendingMatch)) { state.killerModalOpen = true; state.killerSearch = ""; render(); } }
  if (!isTyping && (event.key === "+" || event.key === "=")) { event.preventDefault(); adjustFocusedCounter(1); }
  if (!isTyping && event.key === "-") { event.preventDefault(); adjustFocusedCounter(-1); }
});

document.addEventListener("input", (event) => {
  handleEditFieldEvent(event);
  if (event.target.id === "resultBaseBpInput") state.resultBaseBp = event.target.value.replace(/[^0-9]/g, "");
  if (event.target.dataset && Object.prototype.hasOwnProperty.call(event.target.dataset, "afkSeconds")) {
    state.generalCounts[GENERAL_AFK_BONUS_ID] = event.target.value.replace(/[^0-9]/g, "");
    render();
    setTimeout(() => {
      const input = document.querySelector("[data-afk-seconds]");
      input?.focus();
      input?.setSelectionRange(input.value.length, input.value.length);
    }, 0);
  }
  if (event.target.id === "killerSearch") {
    state.killerSearch = event.target.value;
    updateKillerList();
  }
});

document.addEventListener("change", (event) => {
  handleEditFieldEvent(event);
});

document.addEventListener("pointerdown", (event) => {
  if (event.target.closest("[data-action='toggle-overlay-side']")) return;
  const resizeHandle = event.target.closest("[data-overlay-resize]");
  const resizeItem = resizeHandle && resizeHandle.closest("[data-overlay-drag]");
  const resizeStage = resizeItem && resizeItem.closest("[data-overlay-stage]");
  if (resizeHandle && resizeItem && resizeStage) {
    event.preventDefault();
    event.stopPropagation();
    const key = resizeHandle.dataset.overlayResize;
    setOverlayEditorFocus(key);
    const meta = OVERLAY_EDITOR_PANELS[key];
    const layout = normalizeOverlayLayout(state.overlayLayoutDraft || overlayLayoutFromConfig(state.snapshot && state.snapshot.config));
    state.overlayLayoutDraft = layout;
    const rect = resizeStage.getBoundingClientRect();
    state.overlayResize = {
      key,
      pointerId: event.pointerId,
      startClientX: event.clientX,
      startClientY: event.clientY,
      startScale: layout[key].scale || 1,
      startX: layout[key].x,
      startY: layout[key].y,
      corner: resizeHandle.dataset.corner || "se",
      baseWidth: meta.width,
      baseHeight: meta.height,
      scaleX: rect.width / OVERLAY_EDITOR_WIDTH,
      scaleY: rect.height / OVERLAY_EDITOR_HEIGHT
    };
    resizeItem.setPointerCapture?.(event.pointerId);
    return;
  }
  const dragItem = event.target.closest("[data-overlay-drag]");
  const stage = dragItem && dragItem.closest("[data-overlay-stage]");
  if (dragItem && stage) {
    event.preventDefault();
    const key = dragItem.dataset.overlayDrag;
    setOverlayEditorFocus(key);
    const layout = normalizeOverlayLayout(state.overlayLayoutDraft || overlayLayoutFromConfig(state.snapshot && state.snapshot.config));
    state.overlayLayoutDraft = layout;
    const rect = stage.getBoundingClientRect();
    state.overlayDrag = {
      key,
      pointerId: event.pointerId,
      startClientX: event.clientX,
      startClientY: event.clientY,
      startX: layout[key].x,
      startY: layout[key].y,
      scaleX: rect.width / OVERLAY_EDITOR_WIDTH,
      scaleY: rect.height / OVERLAY_EDITOR_HEIGHT
    };
    dragItem.setPointerCapture?.(event.pointerId);
    return;
  }
  const backdrop = event.target.closest(".modal-backdrop");
  state.backdropPointerDownAction = backdrop && event.target === backdrop ? (backdrop.dataset.action || "") : "";
});

document.addEventListener("pointermove", (event) => {
  if (state.overlayResize && state.overlayLayoutDraft) {
    event.preventDefault();
    const resize = state.overlayResize;
    if (!OVERLAY_EDITOR_PANELS[resize.key]) return;
    const deltaX = (event.clientX - resize.startClientX) / Math.max(.001, resize.scaleX);
    const deltaY = (event.clientY - resize.startClientY) / Math.max(.001, resize.scaleY);
    const xDirection = resize.corner.includes("w") ? -1 : 1;
    const yDirection = resize.corner.includes("n") ? -1 : 1;
    const widthScale = (resize.baseWidth * resize.startScale + deltaX * xDirection) / Math.max(1, resize.baseWidth);
    const heightScale = (resize.baseHeight * resize.startScale + deltaY * yDirection) / Math.max(1, resize.baseHeight);
    const nextScale = Math.round(clamp(Math.max(widthScale, heightScale), .5, 1.8) * 100) / 100;
    const widthDelta = resize.baseWidth * (resize.startScale - nextScale);
    const heightDelta = resize.baseHeight * (resize.startScale - nextScale);
    const nextX = resize.corner.includes("w") ? resize.startX + widthDelta : resize.startX;
    const nextY = resize.corner.includes("n") ? resize.startY + heightDelta : resize.startY;
    state.overlayLayoutDraft[resize.key] = {
      ...state.overlayLayoutDraft[resize.key],
      x: Math.round(clamp(nextX, -600, OVERLAY_EDITOR_WIDTH)),
      y: Math.round(clamp(nextY, -400, OVERLAY_EDITOR_HEIGHT)),
      scale: nextScale
    };
    updateOverlayEditorDom();
    return;
  }
  if (!state.overlayDrag || !state.overlayLayoutDraft) return;
  event.preventDefault();
  const drag = state.overlayDrag;
  if (!OVERLAY_EDITOR_PANELS[drag.key]) return;
  const nextX = drag.startX + (event.clientX - drag.startClientX) / Math.max(.001, drag.scaleX);
  const nextY = drag.startY + (event.clientY - drag.startClientY) / Math.max(.001, drag.scaleY);
  state.overlayLayoutDraft[drag.key] = {
    ...state.overlayLayoutDraft[drag.key],
    x: Math.round(clamp(nextX, -600, OVERLAY_EDITOR_WIDTH)),
    y: Math.round(clamp(nextY, -400, OVERLAY_EDITOR_HEIGHT))
  };
  updateOverlayEditorDom();
});

document.addEventListener("pointerup", () => { state.overlayDrag = null; state.overlayResize = null; });
document.addEventListener("pointercancel", () => { state.overlayDrag = null; state.overlayResize = null; });

function updateOverlayEditorDom() {
  if (!state.overlayEditorOpen || !state.overlayLayoutDraft) return;
  const focusKey = overlayEditorFocusKey();
  for (const [key, meta] of Object.entries(OVERLAY_EDITOR_PANELS)) {
    const pos = state.overlayLayoutDraft[key];
    const item = document.querySelector(`[data-overlay-drag="${key}"]`);
    if (item && pos) {
      item.style.setProperty("--x", `${pos.x}px`);
      item.style.setProperty("--y", `${pos.y}px`);
      item.style.setProperty("--scale", String(pos.scale || 1));

      item.classList.toggle("is-right", pos.side === "right");
      item.classList.toggle("is-left", pos.side === "left");
      item.classList.toggle("is-focused", key === focusKey);
      if (pos.side) item.dataset.side = pos.side;
      item.querySelectorAll("[data-action='toggle-overlay-side']").forEach((sideButton) => {
        sideButton.classList.toggle("is-active", pos.side && sideButton.dataset.sideTarget === pos.side);
      });
    }
    const coords = document.querySelectorAll(`[data-overlay-coord="${key}"]`);
    coords.forEach((coord) => {
      if (!pos) return;
      coord.innerHTML = `<b>${escapeHtml(meta.label)}</b><span class="overlay-editor-coord-xy">(${fmt(pos.x)}, ${fmt(pos.y)})</span><span class="overlay-editor-coord-scale">${Math.round((Number(pos.scale) || 1) * 100)}%</span>${pos.side ? `<span class="overlay-editor-coord-side">${pos.side === "right" ? "Derecha" : "Izquierda"}</span>` : ""}`;
      coord.classList.toggle("is-focused", key === focusKey);
    });
  }
  const focusMeta = OVERLAY_EDITOR_PANELS[focusKey];
  const focusPos = state.overlayLayoutDraft[focusKey];
  const focusSummary = document.querySelector(".overlay-editor-summary");
  if (focusSummary && focusMeta && focusPos) focusSummary.innerHTML = `<b>${escapeHtml(focusMeta.label)}</b><span class="overlay-editor-coord-xy">(${fmt(focusPos.x)}, ${fmt(focusPos.y)})</span><span class="overlay-editor-coord-scale">${Math.round((Number(focusPos.scale) || 1) * 100)}%</span>${focusPos.side ? `<span class="overlay-editor-coord-side">${focusPos.side === "right" ? "Derecha" : "Izquierda"}</span>` : ""}`;
  if (focusSummary) {
    focusSummary.className = `overlay-editor-summary is-${focusKey}`;
    focusSummary.setAttribute("data-overlay-coord", focusKey);
  }
}
function canCloseModalFromClick(el, event, action) {
  if (!el.classList.contains("modal-backdrop")) return true;
  return event.target === el && state.backdropPointerDownAction === action;
}

document.addEventListener("click", (event) => {
  const actionEl = event.target.closest("[data-action]");
  const coordEl = !actionEl && event.target.closest("[data-overlay-coord]");
  const el = actionEl || coordEl;
  if (!el) return;
  const action = el.dataset.action;
  if (action === "count") updateCount(el.dataset.bucket, el.dataset.id, Number(el.dataset.delta));
  if (action === "limited-count") updateLimitedCount(el.dataset.kind, Number(el.dataset.delta));
  if (action === "history-tab") { state.historyTab = el.dataset.tab === "donations" ? "donations" : "matches"; render(); }
  if (action === "modifier-tab") { state.modifierTab = el.dataset.tab === "penalties" ? "penalties" : "bonuses"; render(); }
  if (action === "open-result-modal") { state.resultModalOpen = true; state.resultStep = state.snapshot && state.snapshot.pendingMatch ? (normalizeMatchStatus(state.snapshot.pendingMatch.bonusStatus) === MATCH_STATUS_PENDING_PENALTIES ? "penalties" : "bonuses") : "base"; render(); }
  if (action === "close-result-modal") {
    if (!canCloseModalFromClick(el, event, action)) return;
    state.resultModalOpen = false;
    if (!state.snapshot || !state.snapshot.pendingMatch) state.resultStep = "base";
    render();
  }
  if (action === "close-edit-modal") {
    if (!canCloseModalFromClick(el, event, action)) return;
    state.editModalOpen = false;
    state.editKind = "";
    state.editId = 0;
    state.editValues = {};
    render();
  }
  if (action === "close-overlay-editor") {
    if (!canCloseModalFromClick(el, event, action)) return;
    state.overlayEditorOpen = false;
    state.overlayLayoutDraft = null;
    state.overlayEditorFocusKey = "bonusPanel";
    state.overlayDrag = null;
    state.overlayResize = null;
    render();
  }
  if (action === "close-reset-modal") {
    if (!canCloseModalFromClick(el, event, action)) return;
    state.resetConfirmOpen = false;
    render();
  }
  if (action === "start-match-base") startMatchResult().catch((error) => setError(error.message));
  if (action === "complete-match-bonuses") completePendingBonuses(true).catch((error) => setError(error.message));
  if (action === "complete-match-no-bonuses") completePendingBonuses(false).catch((error) => setError(error.message));
  if (action === "complete-match-penalties") completePendingPenalties(true).catch((error) => setError(error.message));
  if (action === "complete-match-no-penalties") completePendingPenalties(false).catch((error) => setError(error.message));
  if (action === "open-killer-modal") { state.killerModalOpen = true; state.killerSearch = ""; render(); }
  if (action === "close-killer-modal") {
    if (!canCloseModalFromClick(el, event, action)) return;
    state.killerModalOpen = false;
    render();
  }
  if (action === "select-killer") { state.selectedKillerId = el.dataset.id; state.killerCounts = {}; state.penaltyCounts = {}; state.killerModalOpen = false; publishOverlayResult(null); publishOverlayKiller(selectedKiller()); render(); }
  if (action === "save-goal") saveGoal().catch((error) => setError(error.message));
  if (action === "save-donation-config") saveDonationConfig().catch((error) => setError(error.message));
  if (action === "create-donation") createManualDonation().catch((error) => setError(error.message));
  if (action === "resolve-donation") resolveDonation(Number(el.dataset.id), el.dataset.resolution).catch((error) => setError(error.message));
  if (action === "cancel-donation") cancelDonation(Number(el.dataset.id)).catch((error) => setError(error.message));
  if (action === "reset-challenge") { state.resetConfirmOpen = true; render(); }
  if (action === "confirm-reset-challenge") resetChallenge().catch((error) => setError(error.message));
  if (action === "undo") undoLast().catch((error) => setError(error.message));
  if (action === "become-main") becomeMain().catch((error) => setError(error.message));
  if (action === "connect-streamlabs") connectStreamlabs();
  if (action === "open-overlay-editor") { state.overlayEditorOpen = true; state.overlayLayoutDraft = overlayLayoutFromConfig(state.snapshot && state.snapshot.config); state.overlayEditorFocusKey = overlayEditorFocusKey(); render(); }
  if (action === "reset-overlay-layout") { state.overlayLayoutDraft = normalizeOverlayLayout(OVERLAY_LAYOUT_DEFAULT); state.overlayEditorFocusKey = overlayEditorFocusKey(); render(); }
  if (action === "toggle-overlay-side") {
    event.preventDefault();
    event.stopPropagation();
    const key = el.dataset.panel;
    setOverlayEditorFocus(key);
    const targetSide = el.dataset.sideTarget === "right" ? "right" : el.dataset.sideTarget === "left" ? "left" : ((el.dataset.side || "left") === "right" ? "left" : "right");
    setOverlayPanelSide(key, targetSide);
  }
  if (action === "save-overlay-layout") {
    const layout = currentOverlayLayoutDraft();
    saveOverlayLayout(layout).then(() => { state.overlayEditorOpen = false; state.overlayLayoutDraft = null; render(); }).catch((error) => setError(error.message));
  }
  if (!action && el.dataset.overlayCoord) { setOverlayEditorFocus(el.dataset.overlayCoord); return; }
  if (action === "copy-overlay") copyOverlayUrl().catch((error) => setError(error.message));
  if (action === "edit-match") openEditMatch(Number(el.dataset.id));
  if (action === "edit-donation") openEditDonation(Number(el.dataset.id));
  if (action === "save-history-edit") saveHistoryEdit().catch((error) => setError(error.message));
});

load();


